var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _rect, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 617,
    height: 548,
    viewBox: "0 0 617 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7174 444.662C49.9609 454.983 77.339 463.615 112.081 470.765C146.594 477.707 186.472 482.616 231.485 485.284C276.499 487.952 323.775 487.873 373.109 485.277C422.442 482.681 460.953 478.246 487.974 471.788C515.215 465.319 530.345 457.516 533.378 448.597C535.263 442.805 532.54 436.817 524.98 430.427C538.893 428.6 551.244 426.198 561.848 423.889C589.088 417.419 604.219 409.616 607.252 400.698C610.285 391.779 601.668 381.941 581.425 371.62C561.411 361.506 534.033 352.873 499.509 345.712C464.996 338.77 425.118 333.861 380.105 331.193C335.091 328.525 287.815 328.604 238.481 331.2C189.148 333.796 150.637 338.231 123.616 344.689C107.187 348.619 95.1577 352.974 87.5291 357.755L87.104 357.996C86.8858 358.008 86.8972 358.226 86.6789 358.238L13.2423 406.114C8.80757 409.194 5.91229 412.412 4.77493 415.756C1.30532 424.698 9.69223 434.329 29.7174 444.662Z",
    fill: "#59595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.995 463.813L522.904 456.891L534.995 449.889L547.087 456.891L534.995 463.813Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.122 532.592L319 523.336L335.122 514L351.244 523.336L335.122 532.592Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3682 409.244L76 405.542L82.3682 401.92L88.7364 405.542L82.3682 409.244Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.647 490.051L139.279 486.349L145.647 482.646L152.016 486.349L145.647 490.051Z",
    fill: "#C0162E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.49 213.344L145.647 207.468V195.556L135.49 201.432V213.344Z",
    fill: "#292929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.711 117.164L163.623 108.552V91.1675L148.711 99.7794V117.164Z",
    fill: "#292929"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.509 124.086L325.973 119.176V109.277L317.509 114.186V124.086Z",
    fill: "#807DFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7734 190.244L86.2375 185.335V175.435L77.7734 180.345V190.244Z",
    fill: "#C0162E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M534.996 141.954L522.823 134.951V120.706L534.996 127.708V141.954Z",
    fill: "#C0162E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M224.484 394.274H147.421L145.406 395.401L159.835 397.493L143.31 406.99L126.785 416.568L105.262 418.661L103.246 419.788L105.262 420.914L126.785 423.007L143.31 432.504L159.835 442.001L145.406 444.094L147.421 445.221H224.484L248.587 431.297L270.674 418.58L224.484 394.274Z",
    fill: "url(#paint0_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.334 373.428L103.166 360.712V419.788L105.181 420.914L108.728 412.624L125.334 422.122L141.859 431.699L145.406 444.094L147.421 445.221V386.225L125.334 373.428Z",
    fill: "#313131"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.277 407.071V367.794L143.31 388.559V427.836L107.277 407.071Z",
    fill: "#CACACB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.508 373.428L191.595 360.712V419.788L189.58 420.914L186.033 412.624L169.508 422.122L152.983 431.699L149.436 444.094L147.421 445.221V386.225L169.508 373.428Z",
    fill: "#313131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.565 407.071V367.794L151.451 388.559V427.836L187.565 407.071Z",
    fill: "#CACACB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.595 360.712L147.421 335.198L103.166 360.712L147.421 386.225L191.595 360.712Z",
    fill: "#CACACB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.146 413.993L108.728 412.624L105.181 420.914L107.196 419.787L111.146 413.993Z",
    fill: "#292929"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.615 413.993L186.033 412.624L189.58 420.914L187.645 419.787L183.615 413.993Z",
    fill: "#292929"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.863 384.616C169.589 382.764 170.798 382.04 171.523 383.086L183.292 399.747C184.018 400.793 183.454 402.322 181.922 403.208L158.384 416.729C156.933 417.534 156.288 416.729 157.013 414.797L168.863 384.616Z",
    fill: "#C0162E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.717 404.093L169.105 404.978V406.749L170.717 405.864V404.093Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.362 390.41L169.024 391.779L169.347 402.242L171.04 401.276L171.362 390.41Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M405.777 296.646C348.382 263.566 255.358 263.566 197.964 296.646V301.475C255.358 268.395 348.382 268.395 405.777 301.475C433.426 317.411 447.775 338.176 448.742 359.102C448.742 358.458 448.823 357.734 448.823 357.09C448.984 335.198 434.636 313.306 405.777 296.646Z",
    fill: "#CACACB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M405.775 296.646C434.714 313.306 449.062 335.198 448.821 357.09H539.991C540.233 321.757 517.017 286.424 470.263 259.542C377.239 205.939 226.497 205.939 133.553 259.542L198.042 296.726C255.275 263.566 348.38 263.566 405.775 296.646Z",
    fill: "#F1ECEC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M197.883 301.394L133.475 264.291V259.462L197.883 296.646V301.394Z",
    fill: "#CACACB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M518.39 327.793C517.503 327.31 516.455 327.149 515.407 327.149H512.022V332.22H515.407C516.616 332.22 517.826 331.978 518.712 331.415C519.518 330.932 519.921 330.208 519.841 329.564C519.841 328.92 519.357 328.276 518.39 327.793Z",
    fill: "url(#paint1_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M510.409 333.427C511.538 333.427 512.586 333.105 513.311 332.703L515.488 331.496L509.2 327.874L507.024 329.081C506.137 329.564 505.653 330.288 505.734 331.013C505.814 331.737 506.298 332.3 507.185 332.783C507.991 333.186 509.12 333.427 510.409 333.427Z",
    fill: "url(#paint2_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M508.878 326.505C510.49 325.459 513.311 325.379 515.085 326.344C515.972 326.827 516.455 327.471 516.536 328.115C516.616 328.759 516.213 329.403 515.407 329.966C513.795 331.013 510.974 331.093 509.2 330.127C508.313 329.644 507.83 329 507.749 328.357C507.749 327.713 508.072 327.069 508.878 326.505Z",
    fill: "url(#paint3_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M515.407 329.966C513.795 331.013 510.974 331.093 509.2 330.127C508.313 329.644 507.83 329 507.749 328.357V329.564C507.749 329.644 507.749 329.725 507.749 329.805C507.83 330.449 508.313 331.093 509.2 331.576C510.974 332.542 513.795 332.461 515.407 331.415C516.213 330.932 516.616 330.208 516.536 329.564V328.357C516.536 328.92 516.133 329.483 515.407 329.966Z",
    fill: "url(#paint4_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M512.425 315.318C511.538 314.835 510.49 314.674 509.442 314.674H506.056V319.745H509.442C510.651 319.745 511.86 319.503 512.747 318.94C513.553 318.457 513.956 317.733 513.876 317.089C513.795 316.445 513.311 315.801 512.425 315.318Z",
    fill: "url(#paint5_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M504.364 320.872C505.492 320.872 506.54 320.55 507.265 320.147L509.442 318.94L503.154 315.318L500.978 316.525C500.091 317.008 499.607 317.733 499.688 318.457C499.769 319.181 500.252 319.745 501.139 320.228C502.026 320.711 503.154 320.952 504.364 320.872Z",
    fill: "url(#paint6_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M502.913 314.03C504.525 312.984 507.346 312.904 509.119 313.869C510.006 314.352 510.49 314.996 510.57 315.64C510.651 316.284 510.248 316.928 509.442 317.491C507.83 318.537 505.008 318.618 503.235 317.652C502.348 317.169 501.865 316.525 501.784 315.881C501.703 315.238 502.106 314.594 502.913 314.03Z",
    fill: "url(#paint7_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M509.442 317.491C507.83 318.537 505.008 318.618 503.235 317.652C502.348 317.169 501.865 316.525 501.784 315.881V317.089C501.784 317.169 501.784 317.25 501.784 317.33C501.865 317.974 502.348 318.618 503.235 319.101C505.008 320.067 507.83 319.986 509.442 318.94C510.248 318.457 510.651 317.733 510.571 317.089V315.881C510.571 316.445 510.167 317.008 509.442 317.491Z",
    fill: "url(#paint8_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M492.756 319.101C491.869 318.618 490.821 318.457 489.773 318.457H486.387V323.528H489.773C490.982 323.528 492.191 323.286 493.078 322.723C493.884 322.24 494.287 321.515 494.207 320.872C494.126 320.228 493.642 319.584 492.756 319.101Z",
    fill: "url(#paint9_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M484.695 324.654C485.823 324.654 486.871 324.332 487.597 323.93L489.773 322.723L483.485 319.101L481.309 320.308C480.422 320.791 479.939 321.515 480.019 322.24C480.1 322.964 480.583 323.528 481.47 324.01C482.357 324.493 483.485 324.735 484.695 324.654Z",
    fill: "url(#paint10_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M483.244 317.813C484.856 316.767 487.677 316.686 489.451 317.652C490.337 318.135 490.821 318.779 490.902 319.423C490.982 320.067 490.579 320.711 489.773 321.274C488.161 322.32 485.339 322.401 483.566 321.435C482.679 320.952 482.196 320.308 482.115 319.664C482.034 319.02 482.438 318.376 483.244 317.813Z",
    fill: "url(#paint11_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M489.773 321.274C488.161 322.32 485.339 322.401 483.566 321.435C482.679 320.952 482.196 320.308 482.115 319.664V320.872C482.115 320.952 482.115 321.032 482.115 321.113C482.196 321.757 482.679 322.401 483.566 322.884C485.339 323.849 488.161 323.769 489.773 322.723C490.579 322.24 490.982 321.515 490.902 320.872V319.664C490.902 320.228 490.499 320.791 489.773 321.274Z",
    fill: "url(#paint12_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M473.087 322.884C472.2 322.401 471.152 322.24 470.104 322.24H466.719V327.31H470.104C471.313 327.31 472.522 327.069 473.409 326.505C474.215 326.023 474.618 325.298 474.538 324.654C474.457 324.01 473.973 323.367 473.087 322.884Z",
    fill: "url(#paint13_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M465.026 328.437C466.154 328.437 467.202 328.115 467.928 327.713L470.104 326.505L463.817 322.884L461.64 324.091C460.753 324.574 460.27 325.298 460.35 326.023C460.431 326.747 460.915 327.31 461.801 327.793C462.688 328.276 463.817 328.518 465.026 328.437Z",
    fill: "url(#paint14_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M463.575 321.596C465.187 320.55 468.008 320.469 469.782 321.435C470.668 321.918 471.152 322.562 471.233 323.206C471.313 323.849 470.91 324.493 470.104 325.057C468.492 326.103 465.671 326.184 463.897 325.218C463.011 324.735 462.527 324.091 462.446 323.447C462.366 322.803 462.769 322.159 463.575 321.596Z",
    fill: "url(#paint15_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M470.104 325.057C468.492 326.103 465.671 326.183 463.897 325.218C463.01 324.735 462.527 324.091 462.446 323.447V324.654C462.446 324.735 462.446 324.815 462.446 324.896C462.527 325.54 463.01 326.183 463.897 326.666C465.671 327.632 468.492 327.552 470.104 326.505C470.91 326.023 471.313 325.298 471.233 324.654V323.447C471.233 324.01 470.83 324.574 470.104 325.057Z",
    fill: "url(#paint16_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M466.477 313.145C465.59 312.662 464.542 312.501 463.494 312.501H460.108V317.572H463.494C464.703 317.572 465.912 317.33 466.799 316.767C467.605 316.284 468.008 315.56 467.928 314.916C467.847 314.272 467.363 313.628 466.477 313.145Z",
    fill: "url(#paint17_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M458.416 318.779C459.544 318.779 460.592 318.457 461.318 318.055L463.494 316.847L457.206 313.225L455.03 314.433C454.143 314.916 453.66 315.64 453.74 316.364C453.821 317.089 454.304 317.652 455.191 318.135C456.078 318.537 457.206 318.779 458.416 318.779Z",
    fill: "url(#paint18_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M456.965 311.857C458.577 310.811 461.398 310.73 463.172 311.696C464.058 312.179 464.542 312.823 464.623 313.467C464.703 314.111 464.3 314.755 463.494 315.318C461.882 316.364 459.061 316.445 457.287 315.479C456.4 314.996 455.917 314.352 455.836 313.708C455.756 313.064 456.159 312.421 456.965 311.857Z",
    fill: "url(#paint19_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M463.494 315.318C461.882 316.364 459.061 316.445 457.287 315.479C456.4 314.996 455.917 314.352 455.836 313.708V314.916C455.836 314.996 455.836 315.077 455.836 315.157C455.917 315.801 456.4 316.445 457.287 316.928C459.061 317.894 461.882 317.813 463.494 316.767C464.3 316.284 464.703 315.56 464.623 314.916V313.708C464.542 314.272 464.22 314.835 463.494 315.318Z",
    fill: "url(#paint20_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M485.34 308.235C484.453 307.753 483.405 307.592 482.357 307.592H478.971V312.662H482.357C483.566 312.662 484.775 312.421 485.662 311.857C486.468 311.374 486.871 310.65 486.791 310.006C486.71 309.362 486.226 308.718 485.34 308.235Z",
    fill: "url(#paint21_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M477.278 313.789C478.407 313.789 479.455 313.467 480.18 313.065L482.357 311.857L476.069 308.235L473.893 309.443C473.006 309.926 472.522 310.65 472.603 311.374C472.684 312.099 473.167 312.662 474.054 313.145C474.941 313.547 476.069 313.869 477.278 313.789Z",
    fill: "url(#paint22_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M475.827 306.948C477.44 305.901 480.261 305.821 482.034 306.787C482.921 307.27 483.405 307.913 483.485 308.557C483.566 309.201 483.163 309.845 482.357 310.408C480.745 311.455 477.923 311.535 476.15 310.569C475.263 310.087 474.779 309.443 474.699 308.799C474.618 308.155 475.021 307.431 475.827 306.948Z",
    fill: "url(#paint23_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M482.357 310.408C480.745 311.455 477.923 311.535 476.15 310.569C475.263 310.087 474.78 309.443 474.699 308.799V310.006C474.699 310.087 474.699 310.167 474.699 310.247C474.78 310.891 475.263 311.535 476.15 312.018C477.923 312.984 480.745 312.903 482.357 311.857C483.163 311.374 483.566 310.65 483.485 310.006V308.799C483.485 309.362 483.082 309.926 482.357 310.408Z",
    fill: "url(#paint24_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M504.202 303.245C503.316 302.762 502.268 302.601 501.22 302.601H497.834V307.672H501.22C502.429 307.672 503.638 307.431 504.525 306.867C505.331 306.384 505.734 305.66 505.653 305.016C505.573 304.372 505.089 303.728 504.202 303.245Z",
    fill: "url(#paint25_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M496.141 308.879C497.27 308.879 498.318 308.557 499.043 308.155L501.22 306.948L494.932 303.326L492.756 304.533C491.869 305.016 491.385 305.74 491.466 306.465C491.546 307.189 492.03 307.752 492.917 308.235C493.804 308.718 494.932 308.879 496.141 308.879Z",
    fill: "url(#paint26_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M494.69 301.958C496.303 300.911 499.124 300.831 500.897 301.797C501.784 302.279 502.268 302.923 502.348 303.567C502.429 304.211 502.026 304.855 501.22 305.418C499.608 306.465 496.786 306.545 495.013 305.579C494.126 305.096 493.642 304.453 493.562 303.809C493.481 303.165 493.884 302.521 494.69 301.958Z",
    fill: "url(#paint27_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M501.22 305.418C499.608 306.465 496.786 306.545 495.013 305.579C494.126 305.097 493.642 304.453 493.562 303.809V305.016C493.562 305.097 493.562 305.177 493.562 305.257C493.642 305.901 494.126 306.545 495.013 307.028C496.786 307.994 499.608 307.913 501.22 306.867C502.026 306.384 502.429 305.66 502.348 305.016V303.809C502.348 304.372 501.945 304.936 501.22 305.418Z",
    fill: "url(#paint28_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M493.884 291.816C492.998 291.334 491.95 291.173 490.902 291.173H487.516V296.243H490.902C492.111 296.243 493.32 296.002 494.207 295.438C495.013 294.955 495.416 294.231 495.335 293.587C495.255 292.863 494.771 292.219 493.884 291.816Z",
    fill: "url(#paint29_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M485.823 297.37C486.952 297.37 488 297.048 488.725 296.646L490.902 295.438L484.614 291.816L482.438 293.024C481.551 293.507 481.067 294.231 481.148 294.955C481.228 295.68 481.712 296.243 482.599 296.726C483.486 297.128 484.614 297.37 485.823 297.37Z",
    fill: "url(#paint30_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M484.372 290.529C485.984 289.482 488.806 289.402 490.579 290.368C491.466 290.851 491.95 291.495 492.03 292.138C492.111 292.782 491.708 293.426 490.902 293.99C489.289 295.036 486.468 295.116 484.695 294.151C483.808 293.668 483.324 293.024 483.244 292.38C483.163 291.655 483.566 291.012 484.372 290.529Z",
    fill: "url(#paint31_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M490.902 293.909C489.289 294.955 486.468 295.036 484.695 294.07C483.808 293.587 483.324 292.943 483.244 292.299V293.507C483.244 293.587 483.244 293.668 483.244 293.748C483.324 294.392 483.808 295.036 484.695 295.519C486.468 296.485 489.289 296.404 490.902 295.358C491.708 294.875 492.111 294.151 492.03 293.507V292.299C491.95 292.943 491.627 293.507 490.902 293.909Z",
    fill: "url(#paint32_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M483.082 282.158C482.196 281.675 481.148 281.514 480.1 281.514H476.634V286.585H480.019C481.228 286.585 482.438 286.344 483.324 285.78C484.13 285.297 484.533 284.573 484.453 283.929C484.453 283.285 483.969 282.641 483.082 282.158Z",
    fill: "url(#paint33_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M475.021 287.792C476.15 287.792 477.198 287.47 477.923 287.068L480.1 285.861L473.812 282.239L471.636 283.446C470.749 283.929 470.265 284.653 470.346 285.378C470.427 286.102 470.91 286.665 471.797 287.148C472.684 287.551 473.812 287.792 475.021 287.792Z",
    fill: "url(#paint34_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M473.57 280.871C475.183 279.824 478.004 279.744 479.777 280.71C480.664 281.192 481.148 281.836 481.228 282.48C481.309 283.124 480.906 283.768 480.1 284.331C478.488 285.378 475.666 285.458 473.893 284.492C473.006 284.009 472.522 283.366 472.442 282.722C472.361 282.078 472.684 281.434 473.57 280.871Z",
    fill: "url(#paint35_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M480.1 284.331C478.488 285.378 475.666 285.458 473.893 284.492C473.006 284.009 472.522 283.366 472.442 282.722V283.929C472.442 284.009 472.442 284.09 472.442 284.17C472.522 284.814 473.006 285.458 473.893 285.941C475.666 286.907 478.488 286.826 480.1 285.78C480.906 285.297 481.309 284.573 481.228 283.929V282.722C481.148 283.285 480.825 283.848 480.1 284.331Z",
    fill: "url(#paint36_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M468.976 272.098C468.089 271.615 467.041 271.454 465.993 271.454H462.607V276.524H465.993C467.202 276.524 468.411 276.283 469.298 275.72C470.104 275.237 470.507 274.512 470.427 273.868C470.427 273.224 469.943 272.581 468.976 272.098Z",
    fill: "url(#paint37_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M460.995 277.651C462.124 277.651 463.172 277.329 463.897 276.927L466.074 275.719L459.786 272.098L457.61 273.305C456.723 273.788 456.239 274.512 456.32 275.237C456.4 275.961 456.884 276.524 457.771 277.007C458.577 277.41 459.705 277.651 460.995 277.651Z",
    fill: "url(#paint38_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M459.464 270.81C461.076 269.764 463.897 269.683 465.671 270.649C466.557 271.132 467.041 271.776 467.122 272.42C467.202 273.063 466.799 273.707 465.993 274.271C464.381 275.317 461.559 275.398 459.786 274.432C458.899 273.949 458.416 273.305 458.335 272.661C458.335 271.937 458.657 271.293 459.464 270.81Z",
    fill: "url(#paint39_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M465.993 274.19C464.381 275.237 461.559 275.317 459.786 274.351C458.899 273.868 458.416 273.224 458.335 272.581V273.788C458.335 273.868 458.335 273.949 458.335 274.029C458.416 274.673 458.899 275.317 459.786 275.8C461.559 276.766 464.381 276.685 465.993 275.639C466.799 275.156 467.202 274.432 467.122 273.788V272.581C467.122 273.224 466.719 273.788 465.993 274.19Z",
    fill: "url(#paint40_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M453.257 262.842C452.37 262.359 451.322 262.198 450.274 262.198H446.808V267.269H450.193C451.403 267.269 452.612 267.027 453.498 266.464C454.305 265.981 454.708 265.256 454.627 264.613C454.627 263.969 454.143 263.325 453.257 262.842Z",
    fill: "url(#paint41_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M445.196 268.476C446.324 268.476 447.372 268.154 448.098 267.751L450.274 266.544L443.986 262.922L441.81 264.13C440.923 264.613 440.44 265.337 440.52 266.061C440.601 266.786 441.084 267.349 441.971 267.832C442.858 268.234 443.986 268.476 445.196 268.476Z",
    fill: "url(#paint42_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M443.745 261.554C445.357 260.508 448.178 260.427 449.952 261.393C450.838 261.876 451.322 262.52 451.403 263.164C451.483 263.808 451.08 264.452 450.274 265.015C448.662 266.061 445.84 266.142 444.067 265.176C443.18 264.693 442.697 264.049 442.616 263.405C442.535 262.761 442.858 262.118 443.745 261.554Z",
    fill: "url(#paint43_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M450.274 265.015C448.662 266.061 445.84 266.142 444.067 265.176C443.18 264.693 442.697 264.049 442.616 263.405V264.613C442.616 264.693 442.616 264.773 442.616 264.854C442.697 265.498 443.18 266.142 444.067 266.625C445.84 267.59 448.662 267.51 450.274 266.464C451.08 265.981 451.483 265.256 451.403 264.613V263.405C451.322 263.969 450.999 264.532 450.274 265.015Z",
    fill: "url(#paint44_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M435.845 254.632C434.958 254.149 433.91 253.989 432.862 253.989H429.477V259.059H432.862C434.071 259.059 435.28 258.818 436.167 258.254C436.973 257.771 437.376 257.047 437.296 256.403C437.215 255.759 436.731 255.115 435.845 254.632Z",
    fill: "url(#paint45_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M427.784 260.266C428.912 260.266 429.96 259.944 430.686 259.542L432.862 258.335L426.575 254.713L424.398 255.92C423.511 256.403 423.028 257.127 423.108 257.852C423.189 258.576 423.673 259.14 424.559 259.622C425.446 260.025 426.575 260.266 427.784 260.266Z",
    fill: "url(#paint46_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M426.333 253.345C427.945 252.298 430.766 252.218 432.54 253.184C433.426 253.667 433.91 254.31 433.991 254.954C434.071 255.598 433.668 256.242 432.862 256.805C431.25 257.852 428.429 257.932 426.655 256.966C425.768 256.484 425.285 255.84 425.204 255.196C425.124 254.552 425.527 253.908 426.333 253.345Z",
    fill: "url(#paint47_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M432.862 256.805C431.25 257.852 428.429 257.932 426.655 256.966C425.768 256.484 425.285 255.84 425.204 255.196V256.403C425.204 256.484 425.204 256.564 425.204 256.645C425.285 257.288 425.768 257.932 426.655 258.415C428.429 259.381 431.25 259.301 432.862 258.254C433.668 257.771 434.071 257.047 433.991 256.403V255.196C433.991 255.759 433.588 256.323 432.862 256.805Z",
    fill: "url(#paint48_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M417.143 247.55C416.256 247.067 415.208 246.906 414.161 246.906H410.775V251.976H414.161C415.37 251.976 416.579 251.735 417.466 251.172C418.272 250.689 418.675 249.964 418.594 249.32C418.513 248.596 418.03 248.033 417.143 247.55Z",
    fill: "url(#paint49_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M409.082 253.103C410.211 253.103 411.259 252.781 411.984 252.379L414.161 251.172L407.873 247.55L405.696 248.757C404.81 249.24 404.326 249.964 404.407 250.689C404.487 251.413 404.971 251.976 405.858 252.459C406.744 252.862 407.792 253.103 409.082 253.103Z",
    fill: "url(#paint50_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M407.551 246.262C409.163 245.216 411.984 245.135 413.758 246.101C414.644 246.584 415.128 247.228 415.208 247.872C415.289 248.516 414.886 249.159 414.08 249.723C412.468 250.769 409.646 250.85 407.873 249.884C406.986 249.401 406.503 248.757 406.422 248.113C406.422 247.389 406.744 246.745 407.551 246.262Z",
    fill: "url(#paint51_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M414.161 249.642C412.548 250.689 409.727 250.769 407.954 249.803C407.067 249.32 406.583 248.677 406.503 248.033V249.24C406.503 249.32 406.503 249.401 406.503 249.481C406.583 250.125 407.067 250.769 407.954 251.252C409.727 252.218 412.548 252.137 414.161 251.091C414.967 250.608 415.37 249.884 415.289 249.24V248.033C415.208 248.677 414.886 249.24 414.161 249.642Z",
    fill: "url(#paint52_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M397.152 241.594C396.265 241.111 395.217 240.95 394.169 240.95H390.784V246.021H394.169C395.378 246.021 396.587 245.779 397.474 245.216C398.28 244.733 398.683 244.008 398.603 243.365C398.522 242.64 398.038 241.996 397.152 241.594Z",
    fill: "url(#paint53_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M389.091 247.147C390.219 247.147 391.267 246.825 391.993 246.423L394.169 245.216L387.882 241.594L385.705 242.801C384.818 243.284 384.335 244.008 384.415 244.733C384.496 245.457 384.98 246.021 385.866 246.503C386.753 246.906 387.882 247.147 389.091 247.147Z",
    fill: "url(#paint54_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M387.64 240.306C389.252 239.26 392.073 239.179 393.847 240.145C394.733 240.628 395.217 241.272 395.298 241.916C395.378 242.56 394.975 243.204 394.169 243.767C392.557 244.813 389.736 244.894 387.962 243.928C387.075 243.445 386.592 242.801 386.511 242.157C386.431 241.433 386.834 240.789 387.64 240.306Z",
    fill: "url(#paint55_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M394.169 243.686C392.557 244.733 389.736 244.813 387.962 243.847C387.075 243.365 386.592 242.721 386.511 242.077V243.284C386.511 243.365 386.511 243.445 386.511 243.525C386.592 244.169 387.075 244.813 387.962 245.296C389.736 246.262 392.557 246.181 394.169 245.135C394.975 244.652 395.378 243.928 395.298 243.284V242.077C395.298 242.721 394.895 243.284 394.169 243.686Z",
    fill: "url(#paint56_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M388.607 252.459C387.72 251.976 386.672 251.815 385.624 251.815H382.239V256.886H385.624C386.834 256.886 388.043 256.645 388.93 256.081C389.736 255.598 390.139 254.874 390.058 254.23C389.977 253.586 389.494 252.942 388.607 252.459Z",
    fill: "url(#paint57_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M380.546 258.013C381.675 258.013 382.722 257.691 383.448 257.288L385.624 256.081L379.337 252.459L377.16 253.667C376.274 254.149 375.79 254.874 375.871 255.598C375.951 256.323 376.435 256.886 377.322 257.369C378.208 257.852 379.337 258.093 380.546 258.013Z",
    fill: "url(#paint58_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M379.095 251.172C380.707 250.125 383.529 250.045 385.302 251.011C386.189 251.493 386.672 252.137 386.753 252.781C386.834 253.425 386.431 254.069 385.624 254.632C384.012 255.679 381.191 255.759 379.417 254.793C378.531 254.31 378.047 253.667 377.966 253.023C377.886 252.379 378.289 251.654 379.095 251.172Z",
    fill: "url(#paint59_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M385.624 254.632C384.012 255.679 381.191 255.759 379.417 254.793C378.531 254.31 378.047 253.667 377.966 253.023V254.23C377.966 254.31 377.966 254.391 377.966 254.471C378.047 255.115 378.531 255.759 379.417 256.242C381.191 257.208 384.012 257.127 385.624 256.081C386.431 255.598 386.834 254.874 386.753 254.23V253.023C386.672 253.586 386.35 254.149 385.624 254.632Z",
    fill: "url(#paint60_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M379.982 263.325C379.095 262.842 378.047 262.681 376.999 262.681H373.614V267.751H376.999C378.208 267.751 379.417 267.51 380.304 266.947C381.11 266.464 381.513 265.739 381.433 265.095C381.433 264.452 380.949 263.808 379.982 263.325Z",
    fill: "url(#paint61_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M372.001 268.878C373.13 268.878 374.178 268.556 374.903 268.154L377.08 266.947L370.792 263.325L368.616 264.532C367.729 265.015 367.245 265.739 367.326 266.464C367.407 267.188 367.89 267.751 368.777 268.234C369.583 268.717 370.712 268.959 372.001 268.878Z",
    fill: "url(#paint62_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M370.47 262.037C372.082 260.991 374.903 260.91 376.677 261.876C377.563 262.359 378.047 263.003 378.128 263.647C378.208 264.291 377.805 264.934 376.999 265.498C375.387 266.544 372.566 266.625 370.792 265.659C369.905 265.176 369.422 264.532 369.341 263.888C369.261 263.244 369.664 262.6 370.47 262.037Z",
    fill: "url(#paint63_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M376.999 265.498C375.387 266.544 372.566 266.625 370.792 265.659C369.905 265.176 369.422 264.532 369.341 263.888V265.095C369.341 265.176 369.341 265.256 369.341 265.337C369.422 265.981 369.905 266.625 370.792 267.108C372.566 268.073 375.387 267.993 376.999 266.947C377.805 266.464 378.208 265.739 378.128 265.095V263.888C378.128 264.452 377.725 265.015 376.999 265.498Z",
    fill: "url(#paint64_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M363.134 259.461C362.247 258.979 361.2 258.818 360.152 258.818H356.766V263.888H360.152C361.361 263.888 362.57 263.647 363.457 263.083C364.263 262.6 364.666 261.876 364.585 261.232C364.505 260.588 364.021 259.944 363.134 259.461Z",
    fill: "url(#paint65_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M355.073 265.095C356.202 265.095 357.25 264.774 357.975 264.371L360.152 263.164L353.864 259.542L351.687 260.749C350.801 261.232 350.317 261.957 350.398 262.681C350.478 263.405 350.962 263.969 351.849 264.452C352.735 264.854 353.864 265.095 355.073 265.095Z",
    fill: "url(#paint66_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M353.622 258.254C355.234 257.208 358.056 257.127 359.829 258.093C360.716 258.576 361.199 259.22 361.28 259.864C361.361 260.508 360.958 261.152 360.152 261.715C358.539 262.761 355.718 262.842 353.945 261.876C353.058 261.393 352.574 260.749 352.494 260.105C352.413 259.381 352.816 258.737 353.622 258.254Z",
    fill: "url(#paint67_linear)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M360.152 261.635C358.539 262.681 355.718 262.761 353.945 261.796C353.058 261.313 352.574 260.669 352.494 260.025V261.232C352.494 261.313 352.494 261.393 352.494 261.474C352.574 262.118 353.058 262.761 353.945 263.244C355.718 264.21 358.539 264.13 360.152 263.083C360.958 262.6 361.361 261.876 361.28 261.232V260.025C361.2 260.588 360.877 261.232 360.152 261.635Z",
    fill: "url(#paint68_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M369.664 248.194C368.777 247.711 367.729 247.55 366.681 247.55H363.295V252.62H366.681C367.89 252.62 369.099 252.379 369.986 251.815C370.792 251.333 371.195 250.608 371.115 249.964C371.115 249.24 370.631 248.596 369.664 248.194Z",
    fill: "url(#paint69_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M361.603 253.747C362.731 253.747 363.779 253.425 364.505 253.023L366.681 251.815L360.393 248.194L358.217 249.401C357.33 249.884 356.847 250.608 356.927 251.333C357.008 252.057 357.491 252.62 358.378 253.103C359.265 253.506 360.393 253.747 361.603 253.747Z",
    fill: "url(#paint70_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M360.152 246.906C361.764 245.86 364.585 245.779 366.359 246.745C367.245 247.228 367.729 247.872 367.81 248.516C367.89 249.159 367.487 249.803 366.681 250.367C365.069 251.413 362.247 251.494 360.474 250.528C359.587 250.045 359.104 249.401 359.023 248.757C358.942 248.033 359.345 247.389 360.152 246.906Z",
    fill: "url(#paint71_linear)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M366.681 250.286C365.069 251.333 362.247 251.413 360.474 250.447C359.587 249.964 359.104 249.32 359.023 248.677V249.884C359.023 249.964 359.023 250.045 359.023 250.125C359.104 250.769 359.587 251.413 360.474 251.896C362.247 252.862 365.069 252.781 366.681 251.735C367.487 251.252 367.89 250.528 367.81 249.884V248.677C367.81 249.32 367.407 249.884 366.681 250.286Z",
    fill: "url(#paint72_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M376.274 236.845C375.387 236.362 374.339 236.201 373.291 236.201H369.905V241.272H373.291C374.5 241.272 375.709 241.03 376.596 240.467C377.402 239.984 377.805 239.26 377.725 238.616C377.644 237.972 377.16 237.328 376.274 236.845Z",
    fill: "url(#paint73_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M368.213 242.399C369.341 242.399 370.389 242.077 371.115 241.674L373.291 240.467L367.003 236.845L364.827 238.053C363.94 238.535 363.457 239.26 363.537 239.984C363.618 240.709 364.101 241.272 364.988 241.755C365.875 242.157 367.003 242.479 368.213 242.399Z",
    fill: "url(#paint74_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M366.762 235.557C368.374 234.511 371.195 234.431 372.969 235.397C373.855 235.879 374.339 236.523 374.42 237.167C374.5 237.811 374.097 238.455 373.291 239.018C371.679 240.065 368.858 240.145 367.084 239.179C366.197 238.696 365.714 238.053 365.633 237.409C365.552 236.765 365.956 236.04 366.762 235.557Z",
    fill: "url(#paint75_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M373.291 239.018C371.679 240.065 368.858 240.145 367.084 239.179C366.197 238.696 365.714 238.053 365.633 237.409V238.616C365.633 238.696 365.633 238.777 365.633 238.857C365.714 239.501 366.197 240.145 367.084 240.628C368.858 241.594 371.679 241.513 373.291 240.467C374.097 239.984 374.5 239.26 374.42 238.616V237.409C374.339 237.972 374.017 238.535 373.291 239.018Z",
    fill: "url(#paint76_linear)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M354.589 233.384C353.703 232.901 352.655 232.741 351.607 232.741H348.221V237.811H351.607C352.816 237.811 354.025 237.57 354.912 237.006C355.718 236.523 356.121 235.799 356.04 235.155C355.96 234.511 355.476 233.867 354.589 233.384Z",
    fill: "url(#paint77_linear)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M346.528 238.938C347.657 238.938 348.705 238.616 349.43 238.213L351.607 237.006L345.319 233.384L343.143 234.592C342.256 235.075 341.772 235.799 341.853 236.523C341.934 237.248 342.417 237.811 343.304 238.294C344.191 238.696 345.319 239.018 346.528 238.938Z",
    fill: "url(#paint78_linear)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M345.077 232.097C346.69 231.05 349.511 230.97 351.284 231.936C352.171 232.419 352.655 233.062 352.735 233.706C352.816 234.35 352.413 234.994 351.607 235.557C349.995 236.604 347.173 236.684 345.4 235.718C344.513 235.236 344.03 234.592 343.949 233.948C343.868 233.304 344.271 232.58 345.077 232.097Z",
    fill: "url(#paint79_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M351.607 235.557C349.995 236.604 347.173 236.684 345.4 235.718C344.513 235.236 344.03 234.592 343.949 233.948V235.155C343.949 235.236 343.949 235.316 343.949 235.397C344.03 236.04 344.513 236.684 345.4 237.167C347.173 238.133 349.995 238.053 351.607 237.006C352.413 236.523 352.816 235.799 352.735 235.155V233.948C352.735 234.511 352.332 235.075 351.607 235.557Z",
    fill: "url(#paint80_linear)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M539.751 351.858C537.817 318.296 514.601 285.056 470.185 259.462C394.733 216 281.315 207.79 191.595 234.833V292.943L197.963 296.565C255.358 263.486 348.382 263.486 405.777 296.565C434.716 313.225 449.065 335.117 448.823 357.009H539.348C539.51 355.319 539.671 353.629 539.751 351.858Z",
    fill: "url(#paint81_linear)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M445.357 310.972C447.936 310.972 484.211 297.692 487.435 297.128C490.66 296.565 490.015 294.311 487.435 292.863C484.856 291.414 469.862 283.929 469.862 283.929L445.357 310.972Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M471.394 284.734L412.226 250.608C410.936 249.884 408.84 250.125 407.551 251.172L384.335 271.132C383.045 272.178 383.126 273.707 384.415 274.512L443.583 308.638C444.873 309.362 446.969 309.121 448.259 308.074L471.475 288.114C472.684 286.987 472.684 285.458 471.394 284.734Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M413.516 254.31L410.452 252.62L407.551 255.115L410.614 256.886L413.516 254.31Z",
    fill: "#F1ECEC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M418.594 257.288L415.531 255.518L412.629 258.013L415.692 259.783L418.594 257.288Z",
    fill: "#F1ECEC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M423.673 260.186L420.609 258.496L417.707 260.991L420.69 262.681L423.673 260.186Z",
    fill: "#F1ECEC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M428.751 263.083L425.688 261.393L422.786 263.888L425.768 265.659L428.751 263.083Z",
    fill: "#F1ECEC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M433.749 266.061L430.766 264.291L427.864 266.786L430.847 268.556L433.749 266.061Z",
    fill: "#F1ECEC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M438.827 268.959L435.845 267.269L432.943 269.764L435.925 271.454L438.827 268.959Z",
    fill: "#F1ECEC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M443.906 271.937L440.923 270.166L438.021 272.661L441.004 274.432L443.906 271.937Z",
    fill: "#F1ECEC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M448.984 274.834L446.002 273.063L443.1 275.559L446.082 277.329L448.984 274.834Z",
    fill: "#F1ECEC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M454.063 277.732L451.08 276.041L448.178 278.536L451.161 280.227L454.063 277.732Z",
    fill: "#F1ECEC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M459.141 280.71L456.159 278.939L453.257 281.434L456.239 283.205L459.141 280.71Z",
    fill: "#F1ECEC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M464.22 283.607L461.237 281.836L458.335 284.331L461.318 286.102L464.22 283.607Z",
    fill: "#F1ECEC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M469.298 286.504L466.315 284.814L463.414 287.309L466.396 289L469.298 286.504Z",
    fill: "#F1ECEC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M411.017 259.944L405.535 256.806L402.633 259.301L408.115 262.439L411.017 259.944Z",
    fill: "#F1ECEC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M408.357 265.176L400.86 260.83L397.958 263.325L405.455 267.671L408.357 265.176Z",
    fill: "#F1ECEC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M405.535 270.568L395.943 265.095L393.041 267.591L402.553 273.063L405.535 270.568Z",
    fill: "#F1ECEC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M396.507 272.42L391.025 269.281L387.156 272.661L392.557 275.8L396.507 272.42Z",
    fill: "#F1ECEC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M403.923 276.685L398.522 273.627L394.572 277.007L400.054 280.066L403.923 276.685Z",
    fill: "#F1ECEC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M411.42 281.031L406.019 277.893L402.069 281.273L407.47 284.412L411.42 281.031Z",
    fill: "#F1ECEC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M437.215 295.921L431.814 292.782L427.864 296.163L433.265 299.302L437.215 295.921Z",
    fill: "#F1ECEC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M449.871 303.165L439.311 297.048L435.361 300.428L445.921 306.545L449.871 303.165Z",
    fill: "#F1ECEC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M429.799 291.575L413.516 282.239L409.566 285.619L425.768 294.955L429.799 291.575Z",
    fill: "#F1ECEC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M417.466 263.727L413.032 261.152L410.13 263.647L414.564 266.222L417.466 263.727Z",
    fill: "#F1ECEC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M414.805 268.878L410.372 266.383L407.47 268.878L411.903 271.373L414.805 268.878Z",
    fill: "#F1ECEC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M412.145 274.19L407.712 271.615L404.81 274.11L409.243 276.685L412.145 274.19Z",
    fill: "#F1ECEC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M418.594 277.973L414.161 275.398L411.259 277.893L415.692 280.468L418.594 277.973Z",
    fill: "#F1ECEC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M425.124 281.675L420.69 279.1L417.788 281.595L422.222 284.17L425.124 281.675Z",
    fill: "#F1ECEC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M431.653 285.458L427.219 282.883L424.237 285.378L428.67 287.953L431.653 285.458Z",
    fill: "#F1ECEC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M438.102 289.16L433.668 286.585L430.766 289.16L435.2 291.655L438.102 289.16Z",
    fill: "#F1ECEC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M444.631 292.943L440.198 290.368L437.296 292.863L441.729 295.438L444.631 292.943Z",
    fill: "#F1ECEC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M454.949 298.899L446.647 294.07L443.745 296.646L452.047 301.394L454.949 298.899Z",
    fill: "#F1ECEC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M421.335 272.661L416.901 270.086L413.999 272.581L418.433 275.156L421.335 272.661Z",
    fill: "#F1ECEC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M427.864 276.363L423.431 273.868L420.448 276.363L424.882 278.939L427.864 276.363Z",
    fill: "#F1ECEC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M434.313 280.146L429.88 277.571L426.978 280.066L431.411 282.641L434.313 280.146Z",
    fill: "#F1ECEC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M440.843 283.848L436.409 281.353L433.507 283.848L437.941 286.424L440.843 283.848Z",
    fill: "#F1ECEC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M447.291 287.631L442.858 285.056L439.956 287.551L444.389 290.126L447.291 287.631Z",
    fill: "#F1ECEC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M459.705 294.794L449.387 288.839L446.485 291.334L456.803 297.289L459.705 294.794Z",
    fill: "#F1ECEC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M423.995 267.43L419.561 264.854L416.659 267.349L421.093 269.925L423.995 267.43Z",
    fill: "#F1ECEC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M430.444 271.212L426.01 268.637L423.108 271.132L427.542 273.707L430.444 271.212Z",
    fill: "#F1ECEC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M436.973 274.915L432.54 272.339L429.638 274.834L434.071 277.41L436.973 274.915Z",
    fill: "#F1ECEC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M443.422 278.697L438.989 276.122L436.087 278.617L440.52 281.192L443.422 278.697Z",
    fill: "#F1ECEC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M449.952 282.4L445.518 279.824L442.616 282.319L447.05 284.895L449.952 282.4Z",
    fill: "#F1ECEC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M456.481 286.183L452.047 283.607L449.065 286.102L453.498 288.678L456.481 286.183Z",
    fill: "#F1ECEC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M464.381 290.77L458.496 287.309L455.594 289.804L461.479 293.265L464.381 290.77Z",
    fill: "#F1ECEC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M472.361 286.263C472.361 286.826 472.039 287.47 471.475 288.034L448.259 307.994C446.969 309.04 444.873 309.362 443.583 308.557L384.415 274.432C383.77 274.029 383.448 273.546 383.448 272.903V274.754V274.834V274.915C383.529 275.478 383.851 276.041 384.415 276.363L439.553 308.235L443.1 310.248L443.503 310.489C444.47 311.052 445.921 311.052 447.13 310.569C447.372 310.489 447.614 310.408 447.856 310.248L471.394 296.646C472.119 296.243 472.442 295.68 472.361 295.116V286.263Z",
    fill: "url(#paint82_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M539.913 358.699C538.945 393.067 515.73 427.353 470.265 453.591V458.42C516.536 431.78 539.751 396.849 539.993 361.838C539.913 360.792 539.913 359.746 539.913 358.699Z",
    fill: "#F1ECEC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M470.185 458.42L405.777 421.236V416.407L470.185 453.591V458.42Z",
    fill: "#CACACB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M448.742 357.009C448.501 378.499 434.152 399.988 405.696 416.407L470.185 453.591C516.455 426.951 539.671 392.02 539.913 357.009H448.742Z",
    fill: "#F1ECEC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M337.581 250.689H318.476V260.266H337.581V250.689Z",
    fill: "url(#paint83_linear)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M323.958 247.308C320.894 249.079 316.058 249.079 312.995 247.308C311.463 246.423 310.737 245.296 310.737 244.169V255.759C310.737 256.886 311.463 258.013 312.995 258.898C316.058 260.669 320.894 260.669 323.958 258.898C325.489 258.013 326.215 256.886 326.215 255.759V244.169C326.215 245.296 325.489 246.423 323.958 247.308Z",
    fill: "url(#paint84_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M310.737 244.169C310.737 243.043 311.463 241.916 312.995 241.03C316.058 239.26 320.894 239.26 323.958 241.03C325.489 241.916 326.215 243.043 326.215 244.169C326.215 245.296 325.489 246.423 323.958 247.308C320.894 249.079 316.058 249.079 312.995 247.308C311.463 246.423 310.737 245.296 310.737 244.169Z",
    fill: "#F1ECEC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M313.801 244.33C316.38 242.882 320.572 242.882 323.071 244.33C323.716 244.733 324.199 245.135 324.522 245.538C324.844 245.055 325.005 244.572 325.005 244.089C325.005 243.123 324.361 242.157 323.071 241.433C320.491 239.984 316.3 239.984 313.801 241.433C312.511 242.157 311.866 243.123 311.866 244.089C311.866 244.572 312.027 245.055 312.35 245.538C312.753 245.135 313.236 244.733 313.801 244.33Z",
    fill: "#CACACB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M313.801 246.825C316.38 248.274 320.572 248.274 323.071 246.825C323.716 246.423 324.199 246.021 324.522 245.618C324.199 245.135 323.716 244.733 323.071 244.411C320.491 242.962 316.3 242.962 313.801 244.411C313.156 244.813 312.672 245.216 312.35 245.618C312.753 246.021 313.236 246.423 313.801 246.825Z",
    fill: "url(#paint85_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M311.624 256.725C311.302 256.966 310.979 256.725 310.979 256.323V252.298C310.979 251.896 311.302 251.333 311.624 251.172C311.624 251.172 312.511 250.689 313.478 250.125V248.918L311.624 249.964C310.657 250.528 309.931 251.815 309.931 252.942V256.967C309.931 258.013 310.737 258.496 311.624 257.932L313.478 256.886V255.679C312.511 256.162 311.624 256.725 311.624 256.725Z",
    fill: "#CACACB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M309.851 256.886V252.862C309.851 251.815 310.657 250.447 311.544 249.884L313.398 248.838L312.591 248.355L310.737 249.401C309.77 249.964 309.045 251.252 309.045 252.379V256.403C309.045 256.886 309.206 257.288 309.448 257.449C309.448 257.449 309.528 257.53 309.609 257.53L310.334 257.932C310.093 257.852 309.851 257.449 309.851 256.886Z",
    fill: "#CACACB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M312.591 255.196C311.866 255.598 311.221 256.001 310.899 256.162V256.323C310.899 256.725 311.221 256.886 311.544 256.725C311.544 256.725 312.43 256.242 313.398 255.679L312.591 255.196Z",
    fill: "#F1ECEC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M177.887 351.267L142.902 354.808V370.342L177.887 373.883V351.267Z",
    fill: "url(#paint86_linear)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M130.09 336.244L134.604 360.712C134.604 362.643 135.894 364.655 138.473 366.104C143.632 369.082 152.016 369.082 157.175 366.104C159.754 364.575 161.044 362.643 161.044 360.712L165.558 336.244H130.09Z",
    fill: "#F1ECEC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M130.09 336.244C130.09 333.588 131.863 331.013 135.329 329C142.262 324.976 153.547 324.976 160.48 329C163.946 331.013 165.719 333.588 165.719 336.244C165.719 338.9 163.946 341.476 160.48 343.488C153.547 347.512 142.262 347.512 135.329 343.488C131.863 341.476 130.09 338.9 130.09 336.244Z",
    fill: "#CACACB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M138.07 332.944C143.471 329.805 152.338 329.805 157.739 332.944C159.915 334.232 161.205 335.761 161.608 337.451C161.689 337.049 161.769 336.647 161.769 336.244C161.769 334.152 160.399 332.139 157.658 330.53C152.257 327.391 143.39 327.391 137.989 330.53C135.249 332.059 133.878 334.152 133.878 336.244C133.878 336.647 133.959 337.049 134.039 337.451C134.523 335.842 135.813 334.232 138.07 332.944Z",
    fill: "#CACACB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M138.07 341.878C143.471 345.017 152.338 345.017 157.739 341.878C159.915 340.59 161.205 339.061 161.608 337.371C161.205 335.761 159.915 334.152 157.739 332.864C152.338 329.725 143.471 329.725 138.07 332.864C135.894 334.152 134.604 335.681 134.201 337.371C134.523 339.061 135.813 340.671 138.07 341.878Z",
    fill: "#292929"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 342.522C149.517 342.522 152.58 342.602 156.046 342.763C156.61 342.522 157.175 342.281 157.739 341.959C159.915 340.671 161.205 339.142 161.608 337.451C161.205 335.842 159.915 334.232 157.739 332.944C155.643 331.737 153.064 331.013 150.323 330.691C148.146 331.254 146.695 331.657 146.695 331.657L147.582 342.522Z",
    fill: "#F1ECEC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M160.48 329.001C159.109 328.196 157.578 327.552 155.965 327.149C154.031 327.552 152.257 328.035 150.726 328.437C153.305 328.759 155.724 329.483 157.739 330.61C160.48 332.139 161.85 334.232 161.85 336.325C161.85 336.727 161.769 337.129 161.689 337.532C161.366 338.659 160.641 339.786 159.593 340.751C160.963 340.832 162.414 340.912 163.785 340.993C165.074 339.544 165.719 337.934 165.719 336.325C165.639 333.588 163.946 331.013 160.48 329.001Z",
    fill: "#CACACB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M165.155 317.33C160.48 312.662 153.87 322.481 152.177 325.137C152.177 325.137 152.338 325.62 152.822 326.345C157.094 321.998 163.059 318.537 165.155 317.33Z",
    fill: "url(#paint87_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M165.639 317.813C165.478 317.652 165.316 317.411 165.155 317.25C162.979 318.457 157.013 321.918 152.741 326.264C153.144 326.908 153.708 327.793 154.515 328.84C162.737 326.908 169.186 322.32 165.639 317.813Z",
    fill: "#C0162E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 311.535C142.423 313.547 137.344 318.457 141.778 340.751C141.939 340.912 143.632 341.234 144.438 341.395C142.02 319.262 144.277 314.433 147.582 311.535Z",
    fill: "url(#paint88_linear)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M144.358 341.476C145.325 342.039 146.292 342.281 147.501 342.522V311.616C144.277 314.433 142.02 319.262 144.358 341.476Z",
    fill: "url(#paint89_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 311.535C133.556 311.535 138.795 333.266 140.246 338.739C140.488 339.464 140.972 340.188 141.778 340.751C137.264 318.457 142.342 313.547 147.582 311.535Z",
    fill: "url(#paint90_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 311.535C152.902 313.386 157.82 318.457 153.386 340.751C154.111 340.188 154.595 339.544 154.837 338.82C154.837 338.82 154.837 338.82 154.837 338.739C154.837 338.739 154.837 338.739 154.837 338.659C156.449 334.393 161.447 311.535 147.582 311.535Z",
    fill: "url(#paint91_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 311.535C150.806 314.352 152.983 319.342 150.645 341.556C151.451 341.315 153.225 340.832 153.386 340.751C157.82 318.457 152.902 313.386 147.582 311.535Z",
    fill: "url(#paint92_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M147.582 311.535V342.442C148.711 342.12 149.678 341.798 150.645 341.556C152.983 319.423 150.806 314.433 147.582 311.535Z",
    fill: "url(#paint93_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M469.935 129.348L469.936 129.348C516.598 156.178 539.653 191.37 539.413 226.459C539.254 247.333 530.89 268.233 514.195 287.359C503.079 274.915 488.567 263.199 470.434 252.751C395.105 209.313 281.902 201.04 192.095 227.883V104.658C281.649 77.7771 394.722 86.0235 469.935 129.348Z",
    fill: "url(#paint94_linear)",
    stroke: "url(#paint95_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M533.303 258.898C523.388 235.155 502.348 212.7 470.265 194.188C395.781 151.209 284.136 142.678 194.9 168.594",
    stroke: "url(#paint96_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M339.112 97.6868V207.307",
    stroke: "url(#paint97_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M470.185 136.159V245.86",
    stroke: "url(#paint98_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M513.408 412.362V289.63C513.847 289.234 514.221 288.787 514.569 288.37L514.577 288.36C528.365 272.764 536.681 255.885 539.413 238.743V350.649C539.255 371.8 530.578 392.981 513.408 412.362Z",
    fill: "url(#paint99_linear)",
    stroke: "url(#paint100_linear)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M335.888 93.0187C287.683 89.3969 241.412 93.0992 194.82 106.218C194.82 126.098 194.82 145.978 194.82 165.777C241.574 154.107 287.683 147.668 335.888 152.336C335.888 132.537 335.888 112.818 335.888 93.0187Z",
    fill: "#292929"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 111.691C233.19 103.562 264.628 99.216 297.195 98.7331C297.195 97.8478 297.195 97.4454 297.195 96.56C264.628 97.0429 233.19 101.389 201.672 109.518C201.672 110.403 201.672 110.886 201.672 111.691Z",
    fill: "#F1ECEC"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M304.047 98.7331C310.657 98.8136 313.962 98.9746 320.652 99.2965C320.652 98.4112 320.652 98.0088 320.652 97.1234C313.962 96.721 310.657 96.6405 304.047 96.56C304.047 97.4454 304.047 97.9283 304.047 98.7331Z",
    fill: "#F1ECEC"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 118.291C204.412 117.567 205.783 117.164 208.523 116.52C208.523 115.635 208.523 115.233 208.523 114.347C205.783 115.072 204.412 115.394 201.672 116.118C201.672 117.003 201.672 117.486 201.672 118.291Z",
    fill: "#F1ECEC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M215.456 114.911C247.055 107.989 278.413 104.85 310.818 105.494C310.818 104.609 310.818 104.206 310.818 103.321C278.493 102.677 247.055 105.735 215.456 112.738C215.456 113.542 215.456 114.025 215.456 114.911Z",
    fill: "#F1ECEC"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 125.132C204.412 124.408 205.783 124.086 208.523 123.362C208.523 122.476 208.523 122.074 208.523 121.188C205.783 121.832 204.412 122.235 201.672 122.959C201.672 123.764 201.672 124.247 201.672 125.132Z",
    fill: "#F1ECEC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M298.646 111.933C303.483 111.933 305.901 111.933 310.818 112.094C310.818 111.208 310.818 110.806 310.818 109.921C305.901 109.76 303.483 109.76 298.646 109.76C298.646 110.645 298.646 111.047 298.646 111.933Z",
    fill: "#F1ECEC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M257.776 114.347C269.546 112.979 281.315 112.174 293.164 112.013C293.164 111.128 293.164 110.725 293.164 109.84C281.315 110.001 269.546 110.806 257.776 112.174C257.776 112.979 257.776 113.462 257.776 114.347Z",
    fill: "url(#paint101_linear)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M215.456 121.671C227.548 119.015 239.639 116.681 251.892 114.991C251.892 114.106 251.892 113.703 251.892 112.818C239.639 114.428 227.548 116.762 215.456 119.498C215.456 120.384 215.456 120.786 215.456 121.671Z",
    fill: "#F1ECEC"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M208.927 130.042C211.667 129.398 213.038 129.076 215.698 128.432C215.698 127.547 215.698 127.144 215.698 126.259C212.957 126.903 211.587 127.225 208.927 127.869C208.927 128.754 208.927 129.156 208.927 130.042Z",
    fill: "#F1ECEC"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55 126.903C254.23 120.545 285.587 117.808 317.912 119.096C317.912 118.21 317.912 117.808 317.912 116.923C285.668 115.715 254.23 118.371 222.55 124.73C222.55 125.615 222.55 126.018 222.55 126.903Z",
    fill: "#F1ECEC"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M208.927 136.883C211.667 136.239 213.038 135.917 215.698 135.273C215.698 134.388 215.698 133.986 215.698 133.1C212.957 133.744 211.587 134.066 208.927 134.71C208.927 135.515 208.927 135.998 208.927 136.883Z",
    fill: "#F1ECEC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M282.201 125.776C294.132 125.213 306.062 125.213 317.912 125.776C317.912 124.891 317.912 124.488 317.912 123.603C305.981 122.959 294.051 122.959 282.201 123.603C282.201 124.488 282.201 124.891 282.201 125.776Z",
    fill: "#F1ECEC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55 133.744C239.881 130.283 257.212 127.708 274.866 126.259C274.866 125.374 274.866 124.971 274.866 124.086C257.212 125.535 239.881 128.11 222.55 131.571C222.55 132.456 222.55 132.859 222.55 133.744Z",
    fill: "url(#paint102_linear)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M208.927 143.644C211.667 143 213.038 142.678 215.698 142.034C215.698 141.149 215.698 140.746 215.698 139.861C212.957 140.505 211.587 140.827 208.927 141.471C208.927 142.356 208.927 142.758 208.927 143.644Z",
    fill: "#F1ECEC"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55 140.585C254.23 134.227 285.587 131.249 317.912 132.537C317.912 131.651 317.912 131.249 317.912 130.364C285.587 129.076 254.23 132.054 222.55 138.412C222.55 139.217 222.55 139.7 222.55 140.585Z",
    fill: "#F1ECEC"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M208.927 150.485C211.667 149.841 213.038 149.519 215.698 148.875C215.698 147.99 215.698 147.587 215.698 146.702C212.957 147.346 211.587 147.668 208.927 148.312C208.927 149.197 208.927 149.6 208.927 150.485Z",
    fill: "#F1ECEC"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55 147.426C254.23 141.068 285.587 137.929 317.912 139.217C317.912 138.332 317.912 137.929 317.912 137.044C285.587 135.756 254.23 138.815 222.55 145.173C222.55 146.058 222.55 146.541 222.55 147.426Z",
    fill: "#F1ECEC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M208.927 157.326C211.667 156.682 213.038 156.36 215.698 155.716C215.698 154.831 215.698 154.429 215.698 153.543C212.957 154.187 211.587 154.509 208.927 155.153C208.927 155.958 208.927 156.441 208.927 157.326Z",
    fill: "#F1ECEC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M270.674 146.863C280.509 145.978 290.424 145.495 300.339 145.495C300.339 144.61 300.339 144.207 300.339 143.322C290.424 143.322 280.509 143.805 270.674 144.69C270.674 145.495 270.674 145.978 270.674 146.863Z",
    fill: "#F1ECEC"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M250.118 149.278C255.277 148.553 257.857 148.151 263.016 147.587C263.016 146.702 263.016 146.3 263.016 145.414C257.857 145.978 255.277 146.3 250.118 147.105C250.118 147.99 250.118 148.392 250.118 149.278Z",
    fill: "url(#paint103_linear)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55 154.187C229.482 152.739 236.415 151.451 243.347 150.324C243.347 149.439 243.347 149.036 243.347 148.151C236.415 149.278 229.482 150.565 222.55 152.014C222.55 152.899 222.55 153.302 222.55 154.187Z",
    fill: "#F1ECEC"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M476.875 207.871C483.163 211.814 489.289 216.08 495.093 220.748C495.093 219.943 495.093 219.541 495.174 218.736C489.37 214.068 483.324 209.722 476.956 205.778C476.875 206.663 476.875 207.066 476.875 207.871Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M476.311 234.511C489.37 242.56 500.817 251.896 511.619 262.842C511.619 262.118 511.619 261.715 511.619 260.991C500.817 250.045 489.37 240.709 476.311 232.66C476.311 233.384 476.311 233.787 476.311 234.511Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M476.23 238.455C489.289 246.503 500.817 255.759 511.619 266.786C511.619 266.061 511.619 265.659 511.619 264.934C500.817 253.989 489.37 244.733 476.311 236.604C476.231 237.328 476.23 237.65 476.23 238.455Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M476.15 242.479C489.289 250.528 500.736 259.783 511.538 270.729C511.538 269.925 511.538 269.603 511.538 268.798C500.736 257.852 489.289 248.596 476.15 240.548C476.231 241.272 476.15 241.674 476.15 242.479Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M476.069 246.503C489.209 254.552 500.736 263.727 511.538 274.754C511.538 273.949 511.538 273.546 511.538 272.822C500.736 261.876 489.209 252.701 476.069 244.572C476.15 245.377 476.069 245.779 476.069 246.503Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M475.989 250.769C489.128 258.818 500.655 267.912 511.457 278.939C511.457 278.134 511.457 277.732 511.457 276.927C500.655 265.9 489.128 256.806 475.989 248.677C476.069 249.562 475.989 249.964 475.989 250.769Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M476.714 213.746C483.002 217.609 489.048 221.875 494.852 226.543C494.852 225.819 494.852 225.416 494.932 224.612C489.128 219.943 483.082 215.678 476.795 211.814C476.795 212.619 476.795 213.022 476.714 213.746Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M476.634 219.461C482.841 223.324 488.967 227.509 494.69 232.097C494.69 231.372 494.69 230.97 494.771 230.245C489.048 225.658 482.921 221.473 476.714 217.529C476.634 218.334 476.634 218.736 476.634 219.461Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M478.004 227.026C477.359 226.624 477.117 226.463 476.472 226.06C476.472 225.175 476.472 224.773 476.553 223.887C477.198 224.29 477.44 224.451 478.085 224.853C478.085 225.738 478.004 226.221 478.004 227.026Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M481.873 229.521C481.309 229.119 480.987 228.958 480.342 228.555C480.342 227.67 480.342 227.268 480.422 226.382C480.987 226.785 481.309 226.946 481.954 227.348C481.954 228.233 481.873 228.716 481.873 229.521Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M485.662 232.097C485.098 231.694 484.775 231.453 484.211 231.05C484.211 230.165 484.292 229.763 484.292 228.877C484.856 229.28 485.178 229.521 485.743 229.924C485.743 230.809 485.743 231.292 485.662 232.097Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M489.451 234.833C488.886 234.431 488.564 234.189 488 233.787C488 232.901 488.08 232.499 488.08 231.694C488.645 232.097 488.967 232.338 489.531 232.74C489.531 233.545 489.531 233.948 489.451 234.833Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M292.761 168.996C302.757 168.836 312.833 168.996 322.829 169.56C322.829 168.755 322.829 168.353 322.829 167.628C312.833 167.065 302.757 166.904 292.761 167.065C292.761 167.789 292.761 168.192 292.761 168.996Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M292.761 174.791C302.757 174.63 312.833 174.791 322.829 175.355C322.829 174.63 322.829 174.228 322.829 173.423C312.833 172.86 302.757 172.699 292.761 172.86C292.761 173.584 292.761 173.987 292.761 174.791Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M292.761 180.425C302.757 180.264 312.833 180.425 322.829 180.908C322.829 180.184 322.829 179.781 322.829 179.057C312.833 178.574 302.757 178.333 292.761 178.574C292.761 179.299 292.761 179.701 292.761 180.425Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M295.26 187.106C294.293 187.106 293.809 187.106 292.842 187.106C292.842 186.22 292.842 185.818 292.842 184.932C293.809 184.932 294.293 184.932 295.26 184.932C295.26 185.737 295.26 186.22 295.26 187.106Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M301.548 187.025C300.58 187.025 300.097 187.025 299.049 187.025C299.049 186.14 299.049 185.737 299.049 184.852C300.016 184.852 300.5 184.852 301.548 184.852C301.548 185.737 301.548 186.14 301.548 187.025Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M307.916 187.106C306.949 187.106 306.465 187.106 305.417 187.106C305.417 186.22 305.417 185.818 305.417 184.932C306.384 184.932 306.868 184.932 307.916 184.932C307.916 185.818 307.916 186.22 307.916 187.106Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M314.284 187.267C313.317 187.267 312.753 187.186 311.785 187.186C311.785 186.301 311.785 185.898 311.785 185.013C312.753 185.013 313.236 185.093 314.284 185.093C314.284 185.979 314.284 186.381 314.284 187.267Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M233.593 189.198C233.754 175.757 245.846 163.523 258.986 161.994C271.722 160.546 284.378 170.687 284.297 183.725C284.217 197.086 271.803 207.79 258.986 209.158C246.733 210.607 233.432 202.398 233.593 189.198Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M255.922 185.979C255.922 184.45 257.293 183.081 258.986 182.92C260.678 182.759 262.049 183.806 262.049 185.335C262.049 186.864 260.678 188.232 258.986 188.393C257.293 188.554 255.922 187.508 255.922 185.979Z",
    fill: "#292929"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M256.084 181.391C256.97 180.828 257.938 180.506 258.986 180.345C260.033 180.264 261.001 180.425 261.888 180.747C264.951 175.516 266.563 172.94 269.626 167.467C266.482 166.019 262.855 165.294 258.986 165.777C255.116 166.179 251.489 167.628 248.345 169.801C251.489 174.55 253.02 176.804 256.084 181.391Z",
    fill: "#292929"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M256.084 190.486C255.197 190.164 254.471 189.601 253.988 188.796C253.423 188.071 253.182 187.186 253.182 186.301C246.894 187.106 243.75 187.588 237.463 188.635C237.463 191.854 238.43 194.993 240.365 197.81C242.299 200.547 245.04 202.639 248.184 203.927C251.328 198.373 252.94 195.717 256.084 190.486Z",
    fill: "#292929"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M264.87 185.093C264.87 185.979 264.628 186.864 264.064 187.749C263.5 188.635 262.774 189.359 261.968 189.842C265.112 194.43 266.724 196.683 269.868 201.593C273.012 199.581 275.672 197.005 277.607 193.786C279.541 190.566 280.509 187.267 280.509 183.967C274.221 184.289 271.158 184.53 264.87 185.093Z",
    fill: "#292929"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M226.097 209.239C216.665 211.09 207.314 213.263 197.964 215.839C197.964 203.444 197.964 191.049 197.964 178.574C207.234 176.079 216.584 173.826 226.097 171.974C226.097 184.45 226.097 196.844 226.097 209.239Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M197.964 197.569C207.234 195.074 216.584 192.82 226.097 190.969C226.097 190.727 226.097 190.566 226.097 190.325C216.665 192.176 207.314 194.43 197.964 196.925C197.964 197.166 197.964 197.247 197.964 197.569Z",
    fill: "#292929"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M198.528 190.325C198.77 190.084 198.931 189.842 199.173 189.52C200.301 188.152 201.591 186.623 203.203 186.301C204.735 185.979 206.508 186.784 208.523 188.715C209.652 189.842 211.022 190.164 212.554 189.762C215.617 188.876 218.116 185.013 219.245 182.679C221.824 177.769 224.162 176.884 226.097 176.482C226.5 176.401 226.822 176.079 226.822 175.677C226.822 175.355 226.5 175.113 226.097 175.194C223.598 175.677 220.857 176.964 218.035 182.357C216.262 185.818 214.166 187.991 212.473 188.554C211.506 188.876 210.539 188.554 209.733 187.749C207.476 185.576 205.38 184.611 203.364 185.013C201.107 185.496 199.495 187.428 198.125 188.957C197.883 189.198 197.722 189.52 197.48 189.681C197.157 190.003 197.157 190.405 197.48 190.566C197.802 190.808 198.205 190.647 198.528 190.325Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M198.528 207.871C198.77 207.629 199.011 207.307 199.253 206.985C200.301 205.698 201.269 204.571 202.639 204.168C204.17 203.766 206.186 204.41 208.604 206.261C210.458 207.629 213.763 208.273 219.083 203.846C220.293 202.881 221.985 201.754 223.436 201.834C224.323 201.915 225.049 202.398 225.532 203.364C225.693 203.685 226.097 203.766 226.5 203.524C226.822 203.283 226.983 202.881 226.903 202.639C226.177 201.351 225.21 200.627 223.92 200.547C222.388 200.466 220.454 201.271 218.439 202.961C214.811 206.02 211.99 206.744 209.813 205.134C207.072 203.042 204.815 202.398 202.8 202.881C200.785 203.364 199.495 204.973 198.367 206.341C198.125 206.663 197.883 206.905 197.722 207.146C197.399 207.468 197.399 207.871 197.722 208.032C197.802 208.354 198.205 208.193 198.528 207.871Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M215.456 185.818C215.456 185.174 216.101 184.45 216.826 184.289C217.552 184.128 218.197 184.53 218.197 185.174C218.197 185.818 217.552 186.542 216.826 186.703C216.02 186.864 215.456 186.462 215.456 185.818Z",
    fill: "#F6F6FB"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M215.456 205.215C215.456 204.571 216.101 203.846 216.826 203.686C217.552 203.525 218.197 203.927 218.197 204.651C218.197 205.295 217.552 206.02 216.826 206.18C216.02 206.261 215.456 205.859 215.456 205.215Z",
    fill: "#F6F6FB"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M354.993 172.296C351.446 171.974 349.672 171.813 346.045 171.491C346.045 168.192 346.045 166.501 346.045 162.96C349.672 163.202 351.446 163.363 354.993 163.765C354.993 167.226 354.993 168.916 354.993 172.296Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M370.228 174.147C366.842 173.665 365.149 173.423 361.764 173.021C361.764 169.721 361.764 167.95 361.764 164.409C365.23 164.811 366.923 165.053 370.228 165.536C370.228 169.157 370.228 170.848 370.228 174.147Z",
    fill: "#CACACB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M384.818 176.723C381.594 176.079 379.901 175.757 376.596 175.194C376.596 171.894 376.596 170.123 376.596 166.662C379.901 167.226 381.513 167.548 384.818 168.192C384.818 171.733 384.818 173.423 384.818 176.723Z",
    fill: "#CACACB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M399.167 180.103C395.943 179.218 394.33 178.816 391.106 178.091C391.106 174.791 391.106 173.101 391.106 169.56C394.33 170.284 395.943 170.687 399.167 171.572C399.167 175.113 399.167 176.803 399.167 180.103Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M354.993 186.703C351.446 186.301 349.672 186.14 346.045 185.898C346.045 182.679 346.045 181.15 346.045 177.85C349.672 178.172 351.446 178.333 354.993 178.655C354.993 181.874 354.993 183.484 354.993 186.703Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M370.228 188.554C366.842 188.071 365.149 187.83 361.764 187.428C361.764 184.208 361.764 182.598 361.764 179.379C365.23 179.781 366.923 180.023 370.228 180.506C370.228 183.806 370.228 185.335 370.228 188.554Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M447.936 220.265C444.47 218.656 442.777 217.851 439.472 216.402C439.472 213.183 439.472 211.653 439.472 208.515C442.858 209.963 444.551 210.768 447.936 212.378C447.936 215.517 447.936 217.126 447.936 220.265Z",
    fill: "#F1ECEC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M463.575 228.233C459.947 226.302 458.174 225.336 454.627 223.565C454.627 220.346 454.627 218.817 454.627 215.678C458.174 217.448 459.947 218.334 463.575 220.265C463.575 223.404 463.575 225.014 463.575 228.233Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M447.936 234.994C444.47 233.384 442.777 232.58 439.472 231.131C439.472 227.67 439.472 225.98 439.472 222.68C442.858 224.129 444.551 224.933 447.936 226.543C447.936 229.843 447.936 231.533 447.936 234.994Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M463.575 243.043C459.947 241.111 458.174 240.145 454.627 238.374C454.627 234.914 454.627 233.223 454.627 229.924C458.174 231.694 459.947 232.66 463.575 234.592C463.575 237.811 463.575 239.501 463.575 243.043Z",
    fill: "#292929"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M354.993 209.641C351.446 209.239 349.672 209.078 346.045 208.756C346.045 205.215 346.045 203.525 346.045 200.225C349.672 200.547 351.446 200.708 354.993 201.11C354.993 204.41 354.993 206.1 354.993 209.641Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M370.228 211.573C366.842 211.09 365.149 210.849 361.764 210.446C361.764 206.905 361.764 205.215 361.764 201.834C365.23 202.237 366.923 202.478 370.228 202.961C370.228 206.341 370.228 208.032 370.228 211.573Z",
    fill: "#CACACB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M384.818 214.068C381.594 213.424 379.901 213.183 376.596 212.619C376.596 209.078 376.596 207.388 376.596 204.007C379.901 204.571 381.513 204.893 384.818 205.456C384.818 208.836 384.818 210.527 384.818 214.068Z",
    fill: "#292929"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M399.167 217.207C395.943 216.402 394.33 216 391.106 215.356C391.106 211.814 391.106 210.124 391.106 206.824C394.33 207.549 395.943 207.951 399.167 208.756C399.167 211.975 399.167 213.666 399.167 217.207Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M372.566 127.225C372.566 119.337 372.566 111.53 372.566 103.643C360.232 101.872 350.801 112.577 350.881 124.327C350.962 136.722 360.232 148.634 372.566 150.807C384.657 152.98 393.283 142.517 393.202 131.169C393.202 127.708 392.557 124.166 391.348 120.947C384.012 123.201 380.224 124.488 372.566 127.225Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M391.348 120.947C388.365 112.577 381.594 105.252 372.566 103.643C372.566 111.53 372.566 119.337 372.566 127.225C380.224 124.488 384.012 123.201 391.348 120.947Z",
    fill: "#292929"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M360.071 140.585C358.217 142.275 357.25 143.241 355.476 144.931C351.849 144.449 349.995 144.288 346.125 143.805C345.722 143.724 345.4 144.046 345.4 144.449C345.4 144.851 345.722 145.253 346.125 145.253C350.075 145.656 351.929 145.897 355.718 146.38C355.879 146.38 356.04 146.38 356.202 146.219C358.136 144.449 359.104 143.483 360.958 141.712C361.2 141.471 361.2 140.988 360.958 140.666C360.716 140.424 360.313 140.344 360.071 140.585ZM396.91 108.874C393.444 108.069 391.751 107.667 388.204 106.943C388.043 106.943 387.882 106.943 387.72 107.104C385.947 108.794 385.06 109.679 383.287 111.369C383.045 111.611 383.045 112.094 383.287 112.416C383.529 112.738 383.932 112.818 384.173 112.577C385.866 110.886 386.834 110.082 388.446 108.472C391.751 109.116 393.524 109.518 396.91 110.323C397.232 110.403 397.555 110.162 397.555 109.76C397.555 109.357 397.313 108.955 396.91 108.874Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M438.263 125.776C444.631 128.513 450.838 131.49 456.965 134.629C456.965 133.744 456.965 133.342 456.965 132.456C450.838 129.237 444.551 126.259 438.263 123.522C438.263 124.488 438.263 124.891 438.263 125.776Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M424.398 127.305C435.603 131.41 446.405 136.32 457.045 141.632C457.045 140.746 457.045 140.344 457.045 139.458C446.405 134.146 435.603 129.156 424.398 125.132C424.398 125.937 424.398 126.42 424.398 127.305Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M424.398 134.307C435.603 138.332 446.324 143.322 457.045 148.634C457.045 147.748 457.045 147.346 457.045 146.461C446.405 141.149 435.603 136.239 424.398 132.134C424.398 133.02 424.398 133.422 424.398 134.307Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M424.398 141.39C435.603 145.414 446.324 150.404 457.045 155.636C457.045 154.751 457.045 154.348 457.045 153.463C446.405 148.231 435.603 143.241 424.398 139.217C424.398 140.022 424.398 140.505 424.398 141.39Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M446.727 169.318C449.549 170.606 450.999 171.25 453.901 172.699C453.901 169.399 453.901 167.709 453.901 164.409C450.999 162.96 449.549 162.316 446.727 161.028C446.727 164.328 446.727 166.019 446.727 169.318Z",
    fill: "#F1ECEC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M457.045 161.672C451.644 158.936 448.984 157.648 443.745 155.314C443.342 155.153 443.1 155.314 443.1 155.716V171.25C443.1 171.652 443.422 172.135 443.745 172.296C448.984 174.63 451.564 175.838 457.045 178.574C457.448 178.735 457.771 178.574 457.771 178.172V162.719C457.69 162.316 457.368 161.833 457.045 161.672ZM456.32 162.799V176.723C451.564 174.389 448.984 173.101 444.389 171.089V157.085C448.984 159.177 451.564 160.385 456.32 162.799Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M408.76 115.635C408.76 113.301 410.372 111.852 412.387 112.496C414.402 113.14 416.015 115.554 416.015 117.889C416.015 120.223 414.402 121.591 412.387 121.027C410.372 120.303 408.76 117.969 408.76 115.635Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M408.76 128.593C408.76 126.259 410.372 124.81 412.387 125.454C414.402 126.098 416.015 128.513 416.015 130.847C416.015 133.181 414.402 134.549 412.387 133.986C410.372 133.342 408.76 131.008 408.76 128.593Z",
    fill: "#292929"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M408.76 141.632C408.76 139.298 410.372 137.849 412.387 138.493C414.402 139.137 416.015 141.551 416.015 143.885C416.015 146.219 414.402 147.588 412.387 146.944C410.372 146.38 408.76 143.966 408.76 141.632Z",
    fill: "#F1ECEC"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M408.76 154.67C408.76 152.336 410.372 150.887 412.387 151.531C414.402 152.175 416.015 154.59 416.015 156.924C416.015 159.258 414.402 160.626 412.387 159.982C410.372 159.338 408.76 157.004 408.76 154.67Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M508.958 188.393C512.102 186.864 513.714 186.14 516.616 184.691C516.536 184.369 516.455 184.208 516.375 183.806C513.473 185.254 511.86 185.979 508.717 187.508C508.717 187.91 508.797 188.071 508.958 188.393Z",
    fill: "#292929"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M508.958 187.91C506.621 181.311 504.202 174.791 501.542 168.272C501.381 168.353 500.897 168.353 500.736 168.433C503.396 174.872 505.895 181.391 508.152 187.991C508.313 187.991 508.797 187.991 508.958 187.91Z",
    fill: "#292929"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M508.233 209.078C508.555 201.995 508.717 198.454 509.039 191.452C508.717 191.049 508.475 190.888 508.152 190.486C507.83 197.569 507.669 201.11 507.346 208.193C507.749 208.515 507.91 208.676 508.233 209.078Z",
    fill: "#292929"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M483.969 170.606C493.642 177.528 502.59 184.932 510.571 193.705C510.571 193.142 510.651 192.82 510.651 192.257C502.59 183.403 493.642 176.079 483.969 169.077C483.969 169.721 483.969 170.043 483.969 170.606Z",
    fill: "#292929"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M484.533 191.532C484.533 177.286 484.533 162.96 484.533 148.714C484.05 148.392 483.808 148.231 483.324 147.909C483.324 162.155 483.324 176.482 483.324 190.727C483.808 191.049 484.05 191.21 484.533 191.532Z",
    fill: "#292929"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M480.1 167.387C480.1 164.892 481.873 163.926 483.969 165.375C486.065 166.823 487.677 170.043 487.677 172.538C487.677 175.033 486.065 175.918 483.969 174.55C481.873 173.101 480.1 169.882 480.1 167.387Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M481.148 146.541C481.148 144.771 482.438 144.127 483.889 145.092C485.42 146.139 486.629 148.392 486.549 150.163C486.549 151.934 485.34 152.578 483.889 151.531C482.438 150.565 481.148 148.312 481.148 146.541Z",
    fill: "#F1ECEC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M514.762 182.276C514.843 180.747 515.649 180.345 516.536 181.391C517.422 182.518 518.067 184.611 517.987 186.22C517.906 187.83 517.181 188.152 516.213 187.106C515.407 186.059 514.682 183.886 514.762 182.276Z",
    fill: "#F1ECEC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M499.285 166.501C499.366 164.892 500.333 164.409 501.462 165.455C502.59 166.501 503.477 168.675 503.396 170.204C503.316 171.813 502.429 172.216 501.3 171.25C500.172 170.204 499.204 168.111 499.285 166.501Z",
    fill: "#292929"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M505.331 206.02C505.411 203.766 506.621 203.122 507.991 204.571C509.361 206.02 510.329 208.997 510.248 211.251C510.168 213.505 508.958 213.585 507.669 212.136C506.298 210.688 505.25 208.273 505.331 206.02Z",
    fill: "#F1ECEC"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M509.039 182.92C505.976 183.001 504.364 183.162 501.059 183.484C504.122 189.681 505.573 192.74 508.233 198.937C511.215 198.776 512.747 198.695 515.568 198.695C513.069 192.337 511.78 189.198 509.039 182.92Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M478.568 184.45C483.002 187.267 485.098 188.635 488.886 191.532C488.886 194.108 488.886 195.315 488.806 197.891C485.017 195.074 483.002 193.625 478.568 190.808C478.568 188.313 478.568 187.025 478.568 184.45Z",
    fill: "#F1ECEC"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M523.791 187.428V208.837C531.046 219.622 535.882 230.889 538.22 242.238C538.945 238.696 539.429 235.075 539.671 231.533C538.704 216.563 533.383 201.593 523.791 187.428Z",
    fill: "#292929"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M523.791 232.016C528.627 239.179 532.335 246.423 534.915 253.908C535.963 250.93 536.85 247.952 537.575 244.974C535.076 234.511 530.481 224.209 523.71 214.229V232.016H523.791Z",
    fill: "#292929"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M456.723 384.239H410.533V395.507H456.723V384.239Z",
    fill: "url(#paint104_linear)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M435.925 371.442H389.736V382.71H435.925V371.442Z",
    fill: "url(#paint105_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 307.062,
    y: 378.291,
    width: 137.844,
    height: 79.68,
    fill: "url(#pattern0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M328.552 436.957C333.55 436.957 339.677 435.749 342.256 434.301C344.755 432.852 342.74 431.645 337.742 431.645C332.744 431.645 326.618 432.852 324.038 434.301C321.459 435.749 323.474 436.957 328.552 436.957Z",
    fill: "url(#paint106_linear)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M326.859 401.382C331.857 401.382 337.984 400.175 340.563 398.726C343.062 397.278 341.047 396.07 335.968 396.07C330.971 396.07 324.844 397.278 322.265 398.726C319.846 400.175 321.862 401.382 326.859 401.382Z",
    fill: "url(#paint107_linear)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M389.816 400.899C394.814 400.899 400.94 399.692 403.52 398.243C406.019 396.795 404.004 395.587 398.925 395.587C393.927 395.587 387.801 396.795 385.221 398.243C382.722 399.692 384.818 400.899 389.816 400.899Z",
    fill: "url(#paint108_linear)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M388.204 437.198C393.202 437.198 399.328 435.991 401.908 434.542C404.407 433.093 402.391 431.886 397.313 431.886C392.315 431.886 386.189 433.093 383.609 434.542C381.191 435.991 383.206 437.198 388.204 437.198Z",
    fill: "url(#paint109_linear)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M321.217 433.496C321.217 430.598 323.232 427.057 325.731 425.608C328.23 424.16 330.245 425.367 330.245 428.264C330.245 431.162 328.23 434.703 325.731 436.152C323.232 437.52 321.217 436.393 321.217 433.496Z",
    fill: "#292929"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M322.91 432.449C322.91 430.679 324.199 428.506 325.731 427.62C327.263 426.735 328.552 427.459 328.552 429.23C328.552 431.001 327.263 433.174 325.731 434.059C324.199 434.944 322.91 434.301 322.91 432.449Z",
    fill: "#F6F6FB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M321.217 433.496C321.217 430.598 323.232 427.057 325.731 425.608C326.94 424.884 327.988 424.803 328.875 425.286L326.456 423.918C325.65 423.516 324.522 423.596 323.313 424.32C320.814 425.769 318.798 429.311 318.798 432.208C318.798 433.657 319.282 434.623 320.088 435.105L322.507 436.474C321.7 435.91 321.217 434.944 321.217 433.496Z",
    fill: "#CACACB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M325.167 431.242C325.167 430.84 325.408 430.437 325.731 430.196C326.053 430.035 326.295 430.196 326.295 430.518C326.295 430.92 326.053 431.323 325.731 431.564C325.408 431.725 325.167 431.564 325.167 431.242Z",
    fill: "#292929"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M383.77 397.358C383.77 394.461 385.786 390.919 388.285 389.47C390.784 388.022 392.799 389.229 392.799 392.126C392.799 395.024 390.784 398.565 388.285 400.014C385.866 401.382 383.77 400.255 383.77 397.358Z",
    fill: "#292929"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M385.544 396.312C385.544 394.541 386.834 392.368 388.365 391.483C389.897 390.597 391.187 391.322 391.187 393.092C391.187 394.863 389.897 397.036 388.365 397.921C386.834 398.887 385.544 398.163 385.544 396.312Z",
    fill: "#F6F6FB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M383.77 397.358C383.77 394.461 385.786 390.919 388.285 389.471C389.494 388.746 390.542 388.666 391.428 389.149L389.01 387.78C388.204 387.378 387.075 387.458 385.866 388.183C383.367 389.632 381.352 393.173 381.352 396.07C381.352 397.519 381.836 398.485 382.642 398.968L385.06 400.336C384.335 399.773 383.77 398.807 383.77 397.358Z",
    fill: "#CACACB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M387.72 395.104C387.72 394.702 387.962 394.3 388.285 394.058C388.607 393.897 388.849 394.058 388.849 394.38C388.849 394.783 388.607 395.185 388.285 395.426C388.043 395.587 387.72 395.426 387.72 395.104Z",
    fill: "#292929"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M381.755 433.335C381.755 430.437 383.77 426.896 386.269 425.447C388.768 423.999 390.784 425.206 390.784 428.103C390.784 431.001 388.768 434.542 386.269 435.991C383.77 437.359 381.755 436.232 381.755 433.335Z",
    fill: "#292929"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M383.529 432.288C383.529 430.518 384.818 428.345 386.35 427.459C387.882 426.574 389.171 427.298 389.171 429.069C389.171 430.84 387.882 433.013 386.35 433.898C384.738 434.784 383.529 434.059 383.529 432.288Z",
    fill: "#F6F6FB"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M381.755 433.335C381.755 430.437 383.77 426.896 386.269 425.447C387.479 424.723 388.526 424.642 389.413 425.125L386.995 423.757C386.189 423.355 385.06 423.435 383.851 424.16C381.352 425.608 379.337 429.15 379.337 432.047C379.337 433.496 379.821 434.462 380.627 434.944L383.045 436.313C382.239 435.749 381.755 434.703 381.755 433.335Z",
    fill: "#CACACB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M385.705 431.001C385.705 430.598 385.947 430.196 386.269 429.954C386.592 429.793 386.834 429.954 386.834 430.276C386.834 430.679 386.592 431.081 386.269 431.323C385.947 431.564 385.705 431.403 385.705 431.001Z",
    fill: "#292929"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 397.358C319.363 394.461 321.378 390.919 323.877 389.47C326.376 388.022 328.391 389.229 328.391 392.126C328.391 395.024 326.376 398.565 323.877 400.014C321.378 401.382 319.363 400.255 319.363 397.358Z",
    fill: "#292929"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M321.136 396.312C321.136 394.541 322.426 392.368 323.957 391.483C325.489 390.597 326.779 391.322 326.779 393.092C326.779 394.863 325.489 397.036 323.957 397.921C322.345 398.887 321.136 398.163 321.136 396.312Z",
    fill: "#F6F6FB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 397.358C319.363 394.461 321.378 390.919 323.877 389.471C325.086 388.746 326.134 388.666 327.021 389.149L324.602 387.78C323.796 387.378 322.668 387.458 321.459 388.183C318.96 389.632 316.944 393.173 316.944 396.07C316.944 397.519 317.428 398.485 318.234 398.968L320.652 400.336C319.846 399.773 319.363 398.807 319.363 397.358Z",
    fill: "#CACACB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M323.313 395.104C323.313 394.702 323.554 394.3 323.877 394.058C324.199 393.897 324.441 394.058 324.441 394.38C324.441 394.783 324.199 395.185 323.877 395.426C323.554 395.587 323.313 395.426 323.313 395.104Z",
    fill: "#292929"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M387.479 390.034C385.06 390.758 362.247 397.841 362.247 397.841V392.931L385.383 385.849C385.463 385.768 390.139 384.319 387.479 390.034Z",
    fill: "#CACACB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M362.328 392.851L385.463 385.768C385.463 385.768 386.834 385.366 387.64 385.849L384.818 384.239C383.932 383.756 382.642 384.159 382.642 384.159L359.507 391.241L362.328 392.851Z",
    fill: "#F1ECEC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M322.507 390.034C324.925 390.758 347.738 397.841 347.738 397.841V392.931L324.602 385.849C324.602 385.768 319.846 384.319 322.507 390.034Z",
    fill: "#CACACB"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M347.738 392.851L324.602 385.768C324.602 385.768 323.232 385.366 322.426 385.849L325.247 384.239C326.134 383.756 327.424 384.159 327.424 384.159L350.559 391.241L347.738 392.851Z",
    fill: "#F1ECEC"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M360.635 397.278C359.104 398.163 357.008 398.646 354.993 398.646C352.977 398.646 350.962 398.163 349.35 397.278C347.818 396.392 347.012 395.185 347.012 394.058V400.819C347.012 402.026 347.818 403.153 349.35 404.038C350.881 404.924 352.977 405.407 354.993 405.407C357.008 405.407 359.023 404.924 360.635 404.038C362.167 403.153 362.973 401.946 362.973 400.819V394.058C362.973 395.185 362.247 396.392 360.635 397.278Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M347.091 394.058C347.091 392.851 347.897 391.724 349.429 390.839C350.96 389.953 353.056 389.47 355.072 389.47C357.087 389.47 359.102 389.953 360.714 390.839C362.246 391.724 363.052 392.931 363.052 394.058C363.052 395.265 362.246 396.392 360.714 397.278C359.183 398.163 357.087 398.646 355.072 398.646C353.056 398.646 351.041 398.163 349.429 397.278C347.897 396.392 347.091 395.185 347.091 394.058Z",
    fill: "#313131"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M357.814 387.056C357.008 387.539 356.04 387.7 354.993 387.7C353.945 387.7 352.977 387.458 352.171 387.056C351.365 386.573 351.043 386.01 351.043 385.446V394.058C351.043 394.622 351.446 395.265 352.171 395.668C352.977 396.151 353.945 396.312 354.993 396.312C356.04 396.312 357.008 396.07 357.814 395.668C358.62 395.185 358.942 394.622 358.942 394.058V385.446C359.023 386.01 358.62 386.573 357.814 387.056Z",
    fill: "#59595B"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M351.122 385.446C351.122 384.883 351.525 384.239 352.251 383.837C353.057 383.354 354.024 383.193 355.072 383.193C356.12 383.193 357.088 383.434 357.894 383.837C358.7 384.319 359.022 384.883 359.022 385.446C359.022 386.01 358.619 386.654 357.894 387.056C357.088 387.539 356.12 387.7 355.072 387.7C354.024 387.7 353.057 387.458 352.251 387.056C351.445 386.573 351.122 386.01 351.122 385.446Z",
    fill: "#59595B"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M325.57 425.689C327.988 423.677 350.801 404.441 350.801 404.441V399.451L327.666 419.089C327.666 419.089 322.91 423.033 325.57 425.689Z",
    fill: "#CACACB"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M327.666 419.089L350.801 399.451L347.979 397.841L324.844 417.479C324.844 417.479 320.088 421.423 322.748 424.079L325.57 425.689C322.91 423.033 327.666 419.089 327.666 419.089Z",
    fill: "#F1ECEC"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M384.415 425.689C381.997 423.677 359.184 404.441 359.184 404.441V399.451L382.319 419.089C382.319 419.089 387.075 423.033 384.415 425.689Z",
    fill: "#CACACB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M382.319 419.089L359.184 399.451L362.006 397.841L385.141 417.479C385.141 417.479 389.897 421.423 387.237 424.079L384.415 425.689C387.075 423.033 382.319 419.089 382.319 419.089Z",
    fill: "#F1ECEC"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M382.723 378.847C382.723 369.108 388.929 368.866 388.929 368.866C388.929 368.866 392.315 368.866 397.716 366.613C403.117 364.359 410.614 365.245 406.422 373.052C406.422 373.132 406.341 373.213 406.261 373.374C406.019 373.776 405.535 374.178 404.89 374.581L391.348 382.468C389.333 383.595 382.803 380.859 382.723 378.847Z",
    fill: "#C0162E"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M382.723 377.961C382.803 379.973 389.252 382.629 391.348 381.422L404.89 373.534C405.374 373.293 406.099 372.73 406.825 372.166C406.664 372.408 406.583 372.73 406.422 372.971C406.422 373.052 406.341 373.132 406.261 373.293C406.019 373.695 405.535 374.098 404.89 374.5L391.348 382.388C389.413 383.515 383.529 381.181 382.803 379.249C382.803 379.088 382.723 378.927 382.723 378.847C382.723 378.525 382.723 378.283 382.723 377.961Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M385.221 367.579C386.834 367.579 392.396 369.027 392.396 369.027C392.396 369.027 392.396 369.832 392.879 370.476C392.96 370.557 392.96 370.637 393.041 370.637C394.169 371.442 395.298 372.649 392.638 374.259C390.461 375.627 388.768 374.742 387.881 373.937C387.559 373.293 387.075 372.649 386.35 372.247C385.624 371.844 385.221 371.683 384.899 371.603C384.899 371.522 384.899 371.442 384.899 371.442C384.899 371.442 384.576 367.579 385.221 367.579Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M397.877 313.815L382.722 331.28C381.755 342.95 384.98 369.43 384.98 369.43C385.06 369.913 385.624 370.396 386.269 370.798C387.72 371.603 390.139 371.683 391.59 370.798C392.154 370.476 392.476 370.074 392.638 369.591C392.638 369.591 400.134 325.163 397.877 313.815Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M401.908 391.966C401.908 382.227 408.115 381.985 408.115 381.985C408.115 381.985 411.5 381.985 416.901 379.732C422.302 377.478 429.799 378.364 425.607 386.171C425.607 386.251 425.527 386.332 425.446 386.493C425.204 386.895 424.72 387.297 424.076 387.7L410.533 395.587C408.518 396.634 401.988 393.897 401.908 391.966Z",
    fill: "#C0162E"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M401.908 391.08C401.988 393.092 408.437 395.748 410.533 394.541L424.076 386.654C424.559 386.412 425.285 385.849 426.01 385.285C425.849 385.527 425.768 385.849 425.607 386.09C425.607 386.171 425.527 386.251 425.446 386.412C425.204 386.814 424.72 387.217 424.076 387.619L410.533 395.507C408.598 396.634 402.714 394.3 401.988 392.368C401.988 392.207 401.908 392.046 401.908 391.966C401.908 391.644 401.908 391.322 401.908 391.08Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M404.407 380.617C406.019 380.617 411.581 382.066 411.581 382.066C411.581 382.066 411.581 382.871 412.065 383.515C412.145 383.595 412.145 383.676 412.226 383.676C413.354 384.48 414.483 385.688 411.823 387.297C409.646 388.666 407.954 387.78 407.067 386.975C406.744 386.332 406.261 385.607 405.535 385.285C404.81 384.883 404.407 384.722 404.084 384.641V384.48C404.084 384.48 403.762 380.617 404.407 380.617Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M417.062 326.853C417.062 326.29 416.982 325.807 416.74 325.405L401.908 344.318C400.94 355.989 404.165 382.468 404.165 382.468C404.245 382.951 404.81 383.434 405.455 383.837C406.906 384.722 409.324 384.722 410.775 383.837C411.339 383.515 411.742 383.112 411.823 382.629C411.823 382.629 419.32 338.202 417.062 326.853Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M399.973 346.411C405.374 349.55 405.374 354.701 399.973 357.84L366.439 377.156C361.038 380.295 352.091 380.295 346.69 377.156L310.173 356.069C304.772 352.93 304.772 347.779 310.173 344.721C300.016 350.596 301.628 363.313 310.173 368.062L346.69 389.149C352.091 392.287 361.038 392.287 366.439 389.149L400.054 369.752C408.518 365.084 410.211 352.286 399.973 346.411Z",
    fill: "url(#paint110_linear)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M366.439 377.156C361.038 380.295 352.091 380.295 346.69 377.156L310.173 356.069C304.772 352.93 304.772 347.779 310.173 344.64L343.788 325.244C349.189 322.105 358.136 322.105 363.537 325.244L400.054 346.331C405.455 349.47 405.455 354.621 400.054 357.759L366.439 377.156Z",
    fill: "#F1ECEC"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M397.555 312.366C391.267 300.132 344.513 322.829 338.629 324.036C336.21 334.66 335.082 344.238 332.583 353.252C342.256 356.472 366.6 343.755 382.722 331.28L397.877 313.815C397.877 313.251 397.797 312.768 397.555 312.366Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M357.814 337.075C352.091 327.98 338.548 320.173 321.136 328.785C321.136 332.97 321.459 342.789 323.151 346.25C328.149 356.955 336.049 361.059 351.768 366.291C361.441 369.51 385.786 356.794 401.908 344.318L416.74 325.405C410.452 313.251 363.698 335.868 357.814 337.075Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M390.622 276.389C389.494 275.665 388.043 275.101 387.64 274.86C385.705 273.975 382.642 274.699 381.755 275.262C380.868 275.826 375.548 279.126 374.581 281.218C374.581 281.218 372.566 282.265 371.84 282.667L374.742 287.094C374.742 287.094 377.322 285.725 377.886 285.806C379.256 285.886 380.304 285.806 381.11 285.564C383.932 284.84 387.317 282.587 388.285 281.782C386.834 280.494 385.302 281.943 384.254 282.506C384.496 282.104 384.738 281.782 385.06 281.46C386.753 279.689 387.156 279.126 389.091 279.126C391.025 279.045 392.476 277.516 390.622 276.389Z",
    fill: "#DA9D64"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M376.677 287.094C377.725 284.035 374.097 281.379 371.921 281.54C361.925 285.886 357.008 288.542 353.622 287.496C339.193 280.735 345.077 298.442 353.622 299.247C363.537 300.132 368.616 293.291 376.677 287.094Z",
    fill: "url(#paint111_linear)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M334.84 264.638C327.585 266.248 318.476 270.836 324.522 283.472C328.714 292.084 334.84 264.638 334.84 264.638Z",
    fill: "url(#paint112_linear)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M336.21 348.987C350.398 356.955 369.744 354.057 372.404 342.87C362.731 310.434 360.555 288.864 360.796 275.745C354.509 270.916 349.189 266.651 344.594 265.604C339.757 264.558 333.47 263.673 330.648 266.409C321.942 278.16 324.199 298.442 322.023 329.107C323.474 338.765 329.197 345.043 336.21 348.987Z",
    fill: "url(#paint113_linear)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M337.903 265.202C340.321 262.948 341.047 259.246 341.45 255.061C341.208 252.727 341.369 250.312 342.014 247.817C344.271 238.883 351.768 233.088 358.781 234.859C365.794 236.63 369.664 245.322 367.406 254.256C365.311 262.546 358.056 267.133 351.526 267.777C351.204 268.502 352.413 269.467 353.541 270.272C348.221 271.721 343.223 268.904 340.563 267.455C339.193 266.65 338.226 265.926 337.903 265.202Z",
    fill: "#DA9D64"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M342.337 235.422C344.916 232.927 347.979 235.342 349.43 234.537C349.672 234.376 349.995 234.296 350.236 234.135C352.171 232.927 351.284 232.122 353.058 230.996C354.831 229.949 356.605 231.398 357.814 230.996C360.635 230.11 363.134 229.788 364.182 230.754C364.746 231.237 365.23 231.881 365.633 232.605C366.6 234.135 369.825 232.122 369.583 235.503C369.422 238.642 368.213 239.769 367.729 244.598C367.729 244.839 367.648 245.161 367.648 245.402C367.648 245.483 367.648 245.483 367.648 245.563C367.245 248.702 366.278 251.519 364.666 253.049C364.182 253.531 363.698 253.934 363.215 254.336C363.618 252.646 361.038 247.737 359.104 255.383C358.862 256.187 359.507 256.509 358.62 257.475C357.814 258.441 353.703 260.292 350.801 261.982C346.851 264.397 345.642 261.017 340.241 260.292C340.805 258.039 340.483 256.751 340.08 255.141C339.838 254.095 339.273 250.151 340.08 245.966C341.208 241.861 339.838 237.837 342.337 235.422Z",
    fill: "#292929"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M400.457 292.808C401.263 292.406 402.472 291.762 402.472 291.762C402.472 291.279 404.084 286.289 408.357 285.001C409.243 286.369 407.712 287.416 406.503 288.623C407.954 287.416 409.888 286.208 410.775 285.645C411.662 285.082 414.725 284.277 416.659 285.242C417.062 285.484 418.513 286.047 419.642 286.772C421.496 287.898 420.045 289.508 418.11 289.508C416.176 289.508 415.773 290.152 414.08 291.842C412.387 293.613 410.855 297.396 405.132 297.074C404.568 297.074 403.842 297.557 403.842 297.557L400.457 292.808Z",
    fill: "#DA9D64"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M404.89 297.879C405.938 294.82 402.311 292.164 400.134 292.325C390.139 296.671 385.221 299.327 381.836 298.281C367.406 291.52 364.343 278.965 360.716 275.665C352.655 269.95 342.982 282.587 353.541 294.015C364.666 304.398 373.291 309.308 381.836 310.032C391.831 310.917 396.91 304.076 404.89 297.879Z",
    fill: "url(#paint114_linear)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M291.309 292.889C291.309 286.611 295.742 284.035 301.224 287.174L334.838 306.571C340.239 309.71 344.753 317.356 344.753 323.634V372.73C344.753 379.007 340.32 381.583 334.919 378.444C345.076 384.319 355.313 376.512 355.152 366.774V317.678C355.152 311.4 350.719 303.754 345.237 300.615L311.623 281.218C303.158 276.228 291.309 281.138 291.309 292.889Z",
    fill: "#F1ECEC"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M334.759 306.571C340.16 309.71 344.674 317.356 344.674 323.634V372.73C344.674 379.007 340.241 381.583 334.759 378.444L301.145 359.047C295.744 355.908 291.23 348.262 291.23 341.984V292.889C291.23 286.611 295.663 284.035 301.145 287.174L334.759 306.571Z",
    fill: "url(#paint115_linear)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M432.122 270.081L416 262.069L432.122 253.988L448.244 262.069L432.122 270.081Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 233.214L35 226.75L47.5 220.23L60 226.75L47.5 233.214Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M617 342L605 335.08V321L617 327.92V342Z",
    fill: "#C0162E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M194 35L174 23.4659V0L194 11.5341V35Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M560 35L540 23.4659V0L560 11.5341V35Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M441 70L435 66.0548V58L441 61.9452V70Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 186.96,
    y1: 394.274,
    x2: 186.96,
    y2: 445.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 512.042,
    y1: 329.69,
    x2: 519.869,
    y2: 329.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 512.671,
    y1: 329.501,
    x2: 510.343,
    y2: 334.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 509.627,
    y1: 330.795,
    x2: 514.725,
    y2: 325.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 507.762,
    y1: 330.301,
    x2: 516.601,
    y2: 330.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 506.053,
    y1: 317.21,
    x2: 513.88,
    y2: 317.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 506.682,
    y1: 317.02,
    x2: 504.355,
    y2: 321.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 503.638,
    y1: 318.314,
    x2: 508.737,
    y2: 313.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 501.774,
    y1: 317.821,
    x2: 510.613,
    y2: 317.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 486.386,
    y1: 320.993,
    x2: 494.213,
    y2: 320.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 487.015,
    y1: 320.803,
    x2: 484.688,
    y2: 325.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 483.971,
    y1: 322.097,
    x2: 489.07,
    y2: 316.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#FD836C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    stopColor: "#F58871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5941,
    stopColor: "#E8907B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    stopColor: "#D69C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7813,
    stopColor: "#BEAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#A1BEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7ED3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 482.107,
    y1: 321.603,
    x2: 490.946,
    y2: 321.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#E33C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#E23E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    stopColor: "#DC4563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9084,
    stopColor: "#D3506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#C5617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9488,
    stopColor: "#B4778C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    stopColor: "#9E93A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9802,
    stopColor: "#84B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#67D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 466.719,
    y1: 324.775,
    x2: 474.546,
    y2: 324.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 467.348,
    y1: 324.585,
    x2: 465.021,
    y2: 329.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 464.304,
    y1: 325.879,
    x2: 469.403,
    y2: 320.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6597,
    stopColor: "#F5FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8223,
    stopColor: "#E8FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#D6FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 462.44,
    y1: 325.386,
    x2: 471.279,
    y2: 325.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#A5ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8623,
    stopColor: "#A3ADCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#9CB2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#91BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#80CADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    stopColor: "#6ADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 460.089,
    y1: 315.042,
    x2: 467.916,
    y2: 315.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 460.718,
    y1: 314.852,
    x2: 458.391,
    y2: 319.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 457.674,
    y1: 316.146,
    x2: 462.773,
    y2: 311.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6597,
    stopColor: "#F5FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8223,
    stopColor: "#E8FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#D6FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 455.809,
    y1: 315.652,
    x2: 464.649,
    y2: 315.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#A5ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8623,
    stopColor: "#A3ADCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#9CB2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#91BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#80CADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    stopColor: "#6ADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 478.966,
    y1: 310.1,
    x2: 486.793,
    y2: 310.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 479.595,
    y1: 309.91,
    x2: 477.267,
    y2: 314.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 476.551,
    y1: 311.204,
    x2: 481.649,
    y2: 306.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#FD836C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    stopColor: "#F58871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5941,
    stopColor: "#E8907B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    stopColor: "#D69C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7813,
    stopColor: "#BEAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#A1BEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7ED3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 474.686,
    y1: 310.71,
    x2: 483.525,
    y2: 310.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#E33C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#E23E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    stopColor: "#DC4563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9084,
    stopColor: "#D3506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#C5617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9488,
    stopColor: "#B4778C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    stopColor: "#9E93A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9802,
    stopColor: "#84B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#67D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 497.842,
    y1: 305.157,
    x2: 505.669,
    y2: 305.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 498.472,
    y1: 304.967,
    x2: 496.144,
    y2: 309.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 495.428,
    y1: 306.261,
    x2: 500.526,
    y2: 301.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 493.563,
    y1: 305.768,
    x2: 502.402,
    y2: 305.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 487.499,
    y1: 293.663,
    x2: 495.326,
    y2: 293.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 488.129,
    y1: 293.473,
    x2: 485.801,
    y2: 298.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 485.084,
    y1: 294.767,
    x2: 490.183,
    y2: 289.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 483.22,
    y1: 294.273,
    x2: 492.059,
    y2: 294.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 476.665,
    y1: 284.063,
    x2: 484.492,
    y2: 284.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 477.295,
    y1: 283.873,
    x2: 474.967,
    y2: 288.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 474.25,
    y1: 285.167,
    x2: 479.349,
    y2: 280.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 472.386,
    y1: 284.673,
    x2: 481.225,
    y2: 284.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 462.627,
    y1: 273.954,
    x2: 470.454,
    y2: 273.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 463.256,
    y1: 273.764,
    x2: 460.929,
    y2: 278.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 460.212,
    y1: 275.058,
    x2: 465.311,
    y2: 269.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 458.348,
    y1: 274.564,
    x2: 467.187,
    y2: 274.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 446.839,
    y1: 264.742,
    x2: 454.666,
    y2: 264.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 447.469,
    y1: 264.552,
    x2: 445.141,
    y2: 269.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 444.424,
    y1: 265.847,
    x2: 449.523,
    y2: 260.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 442.56,
    y1: 265.353,
    x2: 451.399,
    y2: 265.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 429.473,
    y1: 256.529,
    x2: 437.3,
    y2: 256.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 430.103,
    y1: 256.339,
    x2: 427.775,
    y2: 261.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 427.059,
    y1: 257.633,
    x2: 432.157,
    y2: 252.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 425.194,
    y1: 257.139,
    x2: 434.033,
    y2: 257.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 410.718,
    y1: 249.402,
    x2: 418.545,
    y2: 249.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 411.348,
    y1: 249.212,
    x2: 409.02,
    y2: 253.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 408.303,
    y1: 250.506,
    x2: 413.402,
    y2: 245.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 406.439,
    y1: 250.013,
    x2: 415.278,
    y2: 250.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 390.778,
    y1: 243.44,
    x2: 398.605,
    y2: 243.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 391.407,
    y1: 243.25,
    x2: 389.08,
    y2: 248.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 388.363,
    y1: 244.544,
    x2: 393.462,
    y2: 239.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 386.499,
    y1: 244.05,
    x2: 395.338,
    y2: 244.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 382.204,
    y1: 254.321,
    x2: 390.031,
    y2: 254.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 382.834,
    y1: 254.131,
    x2: 380.506,
    y2: 258.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 379.789,
    y1: 255.425,
    x2: 384.888,
    y2: 250.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#FD836C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    stopColor: "#F58871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5941,
    stopColor: "#E8907B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    stopColor: "#D69C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7813,
    stopColor: "#BEAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#A1BEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7ED3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 377.925,
    y1: 254.932,
    x2: 386.764,
    y2: 254.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#E33C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#E23E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    stopColor: "#DC4563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9084,
    stopColor: "#D3506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#C5617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9488,
    stopColor: "#B4778C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    stopColor: "#9E93A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9802,
    stopColor: "#84B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#67D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 373.631,
    y1: 265.203,
    x2: 381.458,
    y2: 265.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 374.26,
    y1: 265.013,
    x2: 371.932,
    y2: 269.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 371.216,
    y1: 266.307,
    x2: 376.315,
    y2: 261.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6597,
    stopColor: "#F5FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8223,
    stopColor: "#E8FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#D6FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 369.351,
    y1: 265.814,
    x2: 378.191,
    y2: 265.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#A5ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8623,
    stopColor: "#A3ADCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#9CB2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#91BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#80CADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    stopColor: "#6ADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 356.746,
    y1: 261.381,
    x2: 364.573,
    y2: 261.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 357.375,
    y1: 261.191,
    x2: 355.048,
    y2: 265.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 354.331,
    y1: 262.485,
    x2: 359.43,
    y2: 257.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#FDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6597,
    stopColor: "#F5FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8223,
    stopColor: "#E8FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#D6FFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 352.467,
    y1: 261.991,
    x2: 361.306,
    y2: 261.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#A5ABCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8623,
    stopColor: "#A3ADCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9068,
    stopColor: "#9CB2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#91BCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    stopColor: "#80CADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9858,
    stopColor: "#6ADCE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 363.308,
    y1: 250.044,
    x2: 371.135,
    y2: 250.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 363.937,
    y1: 249.854,
    x2: 361.609,
    y2: 254.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 360.893,
    y1: 251.148,
    x2: 365.991,
    y2: 246.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#FD836C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    stopColor: "#F58871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5941,
    stopColor: "#E8907B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6934,
    stopColor: "#D69C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7813,
    stopColor: "#BEAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#A1BEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#7ED3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 359.028,
    y1: 250.654,
    x2: 367.867,
    y2: 250.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#E33C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#E23E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    stopColor: "#DC4563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9084,
    stopColor: "#D3506D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    stopColor: "#C5617A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9488,
    stopColor: "#B4778C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    stopColor: "#9E93A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9802,
    stopColor: "#84B3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#67D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 369.869,
    y1: 238.707,
    x2: 377.696,
    y2: 238.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 370.498,
    y1: 238.517,
    x2: 368.171,
    y2: 243.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 367.454,
    y1: 239.811,
    x2: 372.553,
    y2: 234.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 365.59,
    y1: 239.317,
    x2: 374.429,
    y2: 239.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 348.219,
    y1: 235.254,
    x2: 356.046,
    y2: 235.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 348.848,
    y1: 235.065,
    x2: 346.521,
    y2: 239.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#E9ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 345.804,
    y1: 236.359,
    x2: 350.903,
    y2: 231.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3598,
    stopColor: "#7F7FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#7C87FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6615,
    stopColor: "#7894F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7721,
    stopColor: "#71A6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#68BEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9573,
    stopColor: "#5DDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 343.939,
    y1: 235.865,
    x2: 352.779,
    y2: 235.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    stopColor: "#423EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4240B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    stopColor: "#4347B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9088,
    stopColor: "#4452B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#4763BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "#4979C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#4C95CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    stopColor: "#50B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9941,
    stopColor: "#55D9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ECEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 365.674,
    y1: 357.021,
    x2: 365.674,
    y2: 219.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3427,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#F6FFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5304,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8295,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 427.861,
    y1: 303.393,
    x2: 423.865,
    y2: 281.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 328.028,
    y1: 250.689,
    x2: 328.028,
    y2: 260.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 326.215,
    y1: 250.835,
    x2: 306.653,
    y2: 268.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 312.35,
    y1: 245.618,
    x2: 324.522,
    y2: 245.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 160.394,
    y1: 351.267,
    x2: 160.394,
    y2: 373.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 165.155,
    y1: 320.347,
    x2: 152.723,
    y2: 334.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 143.818,
    y1: 341.395,
    x2: 143.818,
    y2: 311.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 147.501,
    y1: 324.447,
    x2: 138.349,
    y2: 325.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 147.582,
    y1: 323.664,
    x2: 127.866,
    y2: 329.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 152.297,
    y1: 340.751,
    x2: 152.297,
    y2: 311.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 155.108,
    y1: 323.998,
    x2: 138.947,
    y2: 327.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 149.596,
    y1: 342.442,
    x2: 149.596,
    y2: 311.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 191.595,
    y1: 188.421,
    x2: 539.915,
    y2: 188.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0024",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 365.126,
    y1: 288.114,
    x2: 365.126,
    y2: 88.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 363.491,
    y1: 258.898,
    x2: 363.491,
    y2: 153.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 339.61,
    y1: 207.307,
    x2: 339.609,
    y2: 97.6868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 470.683,
    y1: 245.86,
    x2: 470.682,
    y2: 136.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 526.362,
    y1: 413.671,
    x2: 526.362,
    y2: 226.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0024",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 526.362,
    y1: 413.671,
    x2: 526.362,
    y2: 226.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 275.451,
    y1: 113.455,
    x2: 275.305,
    y2: 110.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 248.679,
    y1: 131.831,
    x2: 248.228,
    y2: 126.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 256.56,
    y1: 148.513,
    x2: 256.271,
    y2: 146.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 433.628,
    y1: 384.239,
    x2: 433.628,
    y2: 395.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 412.83,
    y1: 371.442,
    x2: 412.83,
    y2: 382.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 333.122,
    y1: 431.645,
    x2: 333.122,
    y2: 436.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 331.439,
    y1: 396.07,
    x2: 331.439,
    y2: 401.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 394.378,
    y1: 395.587,
    x2: 394.378,
    y2: 400.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 392.783,
    y1: 431.886,
    x2: 392.783,
    y2: 437.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 355.093,
    y1: 344.721,
    x2: 355.093,
    y2: 391.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 376.863,
    y1: 288.919,
    x2: 357.556,
    y2: 320.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 334.84,
    y1: 273.152,
    x2: 313.541,
    y2: 284.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 372.404,
    y1: 301.502,
    x2: 282.873,
    y2: 348.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 405.076,
    y1: 289.134,
    x2: 363.891,
    y2: 348.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 317.969,
    y1: 379.802,
    x2: 317.969,
    y2: 285.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKsAAABjCAYAAADkU/DAAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutVision);
export default __webpack_public_path__ + "static/media/about_vision.623a273769abe8fc2c7060f8ffa3dd5b.svg";
export { ForwardRef as ReactComponent };